import { M3ENCPROMO } from './Models/M3ENCPROMO.class';
import { M3Ubicacion } from '../Maestro/Ubicacion/M3Ubicacion.type';
import { M3CONDIAGRUPACION } from './Models/M3CONDIAGRUPACION.class';
import { M3CONDIPROMO } from './Models/M3CONDIPROMO.class';
import { TypeM3PrdGrp } from '../Maestro/M3PrdGrp.type';
import { M3DETCONDIPROMO } from './Models/M3DETCONDIPROMO.class';
import { PromocionesAsociadas, PromocionProcesada, PromocionCombinada } from './Models/M3PromoProcesada.class';
import { M3Procesos } from '../Registro/m3-procesos';
import { M3PromCombinadaXProceso } from '../Registro/m3-prom-comb';
import { M3PEncItems } from '../Registro/m3-penc-items';
import { M3PEncFP } from '../Registro/m3-penc-fp';
import { M3PDinamicas } from '../Registro/m3-pdinamicas';
import { PostServiceM3 } from '../../ConexionSQL/posts.service';
import { _iterableDiffersFactory } from '@angular/core/src/application_module';
import { M3PDetalleItems, M3PItemsWEB } from '../Registro/m3-pdetalle-items';
import * as moment_ from 'moment';
import { M3PrdGeneral } from '../Maestro/M3PrdGeneral.type';
import { MathTF } from '../Miscelanea/MathTF.class';
import { M3PerXProceso } from '../Registro/m3-per-x-proceso';
import * as _ from "lodash";
import { M3RegService } from '../Services/m3-reg-service';

const moment = moment_;
export class promocionesService {
    public oMathTF: MathTF = new MathTF();
    public goDataUser: any;
    public goDataAdicional: M3PItemsWEB;
    public goM3ENCPROMO: Array<M3ENCPROMO>;

    constructor(oDataUser: any, oDataAdicional: M3PItemsWEB) {
        this.goDataUser = oDataUser;
        this.goDataAdicional = oDataAdicional;
    }

    public operators = {
        '<': function (a, b) { return a < b },
        '>': function (a, b) { return a > b },
        '<=': function (a, b) { return a <= b },
        '>=': function (a, b) { return a >= b },
        'IGUAL': function (a, b) { return a == b },
        'DIFF': function (a, b) { return a != b },
        'EN': function (a, b) { return a === b },
        'AND': function (a, b) { return a && b },
        'OR': function (a, b) { return a || b },
        '*': function (a, b) { return true },
        'MOD': function (a, b) { return a % b == 0 },
        // ...
    };


    //--------------------------> Inicio Obtener informacion de promocion <--------------------------------
    //Verificar promociones, ingresando como parametro la informacion del producto a validar, Ubicacion
    public VerificarPromociones(oM3Procesos: M3Procesos, oTypeM3PrdGrp: TypeM3PrdGrp, oM3Ubicacion: M3Ubicacion, oM3ENCPROMO: Array<M3ENCPROMO>, lTiposPromo: Array<any>) {
        var jResp;
        var aResps = new Array<any>();
        var aPromociones = new Array<any>();
        var hoy = new Date();
        this.goM3ENCPROMO = oM3ENCPROMO;
        if (oM3ENCPROMO) {
            oM3ENCPROMO.filter(x => lTiposPromo.find(promo => x.Tipo == promo)).forEach(encabezadoPromo => {
                var dVigencia = new Date(encabezadoPromo.Vigencia);
                var dInicio = new Date(encabezadoPromo.Inicio);

                //JAGM 20191023, se quita Tipo Manual, y se deja el nuevo parametro.
                if (this.validarEstadosEncPromo(encabezadoPromo) && (encabezadoPromo.Estado && dVigencia >= hoy && dInicio <= hoy)) {
                    /////// Validacion: 1. Si es diferente a Manual, no valida Variable estados manuales. De lo contrario lo valida. --- 2. Si el estado el estado es verdadero y la vigencia es mayor o igual a la fecha del momento
                    aResps = new Array<any>();
                    encabezadoPromo.M3CONDIAGRUPACION.forEach(agrupacion => {
                        jResp = this.VerificarAgrupacionPromo(oM3Procesos, oTypeM3PrdGrp, oM3Ubicacion, agrupacion, encabezadoPromo);
                        if (jResp) {
                            aResps.push(jResp);
                        }
                    });

                    jResp = this.GetJRespFromArray(aResps, encabezadoPromo.Tipo, encabezadoPromo.Tipo2);
                    if (jResp.APLCondicion) {
                        //Validacion de accion, si existe, sino existe se agrega del papa. Se envia como referencia jresp
                        this.ValidarAccion(jResp, encabezadoPromo.JAdicionales);
                        this.RetomarValoresPromocion(encabezadoPromo, jResp);
                        aPromociones.push(jResp);
                    }
                }

            });
            return aPromociones;
        } else {
            return null;
        }

    }

    validarEstadosEncPromo(encabezadoPromo: M3ENCPROMO): boolean {
        let estado = true;

        if (encabezadoPromo.EsManual && !encabezadoPromo.EstadoManuales) {
            estado = false;
        }

        if (encabezadoPromo.EsAplCupon && !encabezadoPromo.EstadoAplCupon) {
            estado = false;
        }

        return estado;
    }

    //Verificar agrupacion de promociones, ingresando como parametro la informacion del producto a validar, Ubicacion
    public VerificarAgrupacionPromo(oM3Procesos: M3Procesos, oTypeM3PrdGrp: TypeM3PrdGrp, oM3Ubicacion: M3Ubicacion, agrupacion: M3CONDIAGRUPACION, oM3EncPromo: M3ENCPROMO) {
        var jResp;
        var aResps = new Array<any>();
        for (var i = 0; i < agrupacion.M3CONDIPROMO.length; i++) {
            var condicion: M3CONDIPROMO;
            var jAdicionales;
            condicion = agrupacion.M3CONDIPROMO[i];
            jAdicionales = JSON.parse(condicion.JAdicionales);
            if (!jAdicionales.ROOT.ACTIVIDAD || jAdicionales.ROOT.ACTIVIDAD == "REGISTRO") {
                jResp = this.VerificarCondicionesPromo(oM3Procesos, oTypeM3PrdGrp, oM3Ubicacion, condicion);

                if (oM3EncPromo.Tipo == "COMBINADA" && oM3EncPromo.Tipo2 == "COMBO" && jResp.APLCondicion && agrupacion.Operador.trim().toUpperCase() == "OR") {
                    aResps.push(jResp);
                } else if (agrupacion.Operador.trim().toUpperCase() == "AND" && !jResp.APLCondicion) {
                    //La condicion NO se cumple
                    jResp = this.ValidarRespuesta(null);
                    return jResp;
                } else if (agrupacion.Operador.trim().toUpperCase() == "OR" && jResp.APLCondicion) {
                    //La condicion se cumple
                    return jResp;
                } else {
                    //Se debe guardar la informaciÃ³n. Si siempre fueron OR y FALSE, se debe comparar como un AND.
                    aResps.push(jResp);
                }
            } else {
                return null;
            }
        }
        return this.GetJRespFromArray(aResps, oM3EncPromo.Tipo, oM3EncPromo.Tipo2);


    }

    //Verificar condicion de promociones.
    public VerificarCondicionesPromo(oM3Procesos: M3Procesos, oTypeM3PrdGrp: TypeM3PrdGrp, oM3Ubicacion: M3Ubicacion, condicion: M3CONDIPROMO) {
        var jAdicionaes;
        var jResp;
        jAdicionaes = JSON.parse(condicion.JAdicionales);
        jResp = this.VerificarCondicionContraData(oM3Procesos, oTypeM3PrdGrp, oM3Ubicacion, condicion, jAdicionaes);
        this.ValidarAccion(jResp, condicion.JAdicionales);
        this.AgregarCondicionOK(jResp, condicion);
        return jResp;
    }

    /**
     * Agregar a json de respuesta si se genero OK la informacion de la condicion
     * @param jResp 
     * @param condicion 
     */
    public AgregarCondicionOK(jResp, condicion: M3CONDIPROMO) {
        if (jResp.APLCondicion) {
            jResp.IDCondicion = condicion.IdCondicion;
        }
    }


    //Verifica condicion, contra data ingresada.
    public VerificarCondicionContraData(oM3Procesos: M3Procesos, oTypeM3PrdGrp: TypeM3PrdGrp, oM3Ubicacion: M3Ubicacion, condicion: M3CONDIPROMO, jAdicionales): any {
        var objectFinded;
        var jResp;
        try {

            switch (jAdicionales.ROOT.Estructura.Est) {
                //Va a estructura de producto adicional
                case "LoM3PrdAdicionales":
                    objectFinded = oTypeM3PrdGrp.LoM3PrdAdicionales.find(adic => adic.ATRIBUTO.trim() == condicion.Concepto.trim() && this.operators[jAdicionales.ROOT.Estructura.Operacion](adic.VALOR.trim(), condicion.Valor.trim()))
                    objectFinded.JAdicionales = JSON.stringify(jAdicionales);
                    jResp = this.ValidarRespuesta(objectFinded);
                    break;
                case "PRDTO":
                    jResp = this.VerificarInfoProducto(oTypeM3PrdGrp.LoM3PrdGeneral[0], condicion, jAdicionales);
                    break;
                case "PRDGRP":
                    jResp = this.VerificarInfoProductoPRDGRP(oTypeM3PrdGrp, condicion, jAdicionales);
                    break;
                case "M3DETCONDIPROMO":
                    jResp = this.VerificacionM3DetalleCondicion(oM3Procesos, oTypeM3PrdGrp, oM3Ubicacion, condicion.M3DETCONDIPROMO, condicion.Concepto, jAdicionales);
                    break;
                case "PROCESO":
                    jResp = this.VerificarInfoProceso(oM3Procesos, condicion, jAdicionales);
                    break;
                case "ID_PAGO":
                    jResp = this.VerificarProcesoFormaPago(oM3Procesos, condicion, jAdicionales);
                    break;
                case "USER":
                    jResp = this.VerificarInfoUserData(condicion, jAdicionales)
                    break;
                case "ADICIONAL":
                    jResp = this.VerificarInfoAdicional(condicion, jAdicionales)
                    break;

                    // case "CARACTERISTICAS":
                    //     //Esta promociÃ³n esta diseÃ±ada para que sea procesada al final de la transacciÃ³n
                    //     jResp = this.VerificarClasificacionesProceso(oM3Procesos, condicion.M3DETCONDIPROMO, jAdicionales);
                    break;
                default:
                    console.log("No Entro por Detalle!");
                    jResp = this.GenerarRespuesta(false, null);
                    break;
            }
        } catch {
            jResp = this.GenerarRespuesta(false, null);
        }
        return jResp;
    }


    public GetJRespFromArray(aResps: Array<any>, tipo, tipo2) {
        var bAPLCondicion;
        var jResp;
        if (aResps.length > 0) {
            //LLega a este punto, por alguna de 2 razones: 
            //1. La condiciÃ³n es un OR y todos son FALSE
            //2. La condiciÃ³n es un AND y todos son TRUE
            bAPLCondicion = aResps.filter(resp => resp.APLCondicion);
            if (!bAPLCondicion) {
                jResp = this.ValidarRespuesta(null);
            } else {
                if (tipo == "COMBINADA" && tipo2 == "COMBO") {
                    let arregloCondiciones = [];
                    bAPLCondicion.forEach(condicion => {
                        if (condicion.IDCondicion.length >= 0) {
                            condicion.IDCondicion.forEach(idCon => {
                                if (!arregloCondiciones.find(x => x == idCon)) arregloCondiciones.push(idCon);
                            });
                        }
                        else {
                            if (!arregloCondiciones.find(x => x == condicion.IDCondicion)) arregloCondiciones.push(condicion.IDCondicion);
                        }
                    });
                    return { APLCondicion: true, Accion: null, IDCondicion: arregloCondiciones };
                }
                else {
                    var aRespTMP = new Array<any>();
                    //Verificar si alguno de los arreglos tiene accion diferente a null
                    aRespTMP = aResps.filter(resp => resp.Accion != null);
                    if (aRespTMP.length > 0) {
                        //Usar el ultimo item, que tenga la acciÃ³n
                        jResp = aRespTMP[aRespTMP.length - 1];
                    } else {
                        jResp = aResps[aResps.length - 1];
                    }
                }

            }

            //Si la promo depende de la forma de pago aÃ±ade esta informaciÃ³n
            if (aResps.find(x => x.FormaPago)) {
                jResp["FormaPago"] = true;
            }
        }
        else {
            jResp = this.ValidarRespuesta(null);
        }
        return jResp;
    }

    //Generar Respuesta de condicion.
    public GenerarRespuesta(bAPLPromo: boolean, jAdicionales) {
        var jResp;
        jResp = { "APLCondicion": bAPLPromo, "Accion": null };
        if (jAdicionales != null && jAdicionales.ROOT.Accion !== undefined) {
            jResp.Accion = jAdicionales.ROOT.Accion;
        }
        return jResp;
    }


    /**
     * Verificar clasificaciones por proceso.
     * @param oM3Procesos Procesos de M3
     * @param detCondiciones Condiciones de promociones
     * @param jAdicionales JSON 
     */
    public VerificarClasificacionesProceso(oListEncab: Array<M3PEncItems>, combi: PromocionCombinada, lPrecios: Array<any>, bEsAcumulable: boolean) {
        var jResp: any = null;
        try {
            var valores: Array<any> = combi.Accion.Valores;
            //var iCantidadReal: number = lPrecios.length;
            var bEntro: boolean = false;
            valores = valores.sort((a, b) => (a.Cantidad < b.Cantidad) ? 1 : ((b.Cantidad < a.Cantidad) ? -1 : 0));

            this.AplicarPromoByValores(valores, lPrecios, lPrecios.length);//JAGM 20190731, funcion recursiva para calcular los precios nuevos.

            if (lPrecios.length > 0 && lPrecios.find(x => x.Aplicado == true)) {
                this.CalculateTotalPriceFromList(lPrecios, oListEncab, combi, false, bEsAcumulable);
            }

        } catch (ex) {
            jResp = this.GenerarRespuesta(false, null);
            console.log("VerificarClasificacionesProceso");
            console.log(ex);
        }
        return jResp;
    }

    /**
     * Verificar clasificaciones por proceso.
     * @param oM3Procesos Procesos de M3
     * @param detCondiciones Condiciones de promociones
     * @param jAdicionales JSON 
     */
    public procesarCaracteristicaParcial(oListEncab: Array<M3PEncItems>, combi: PromocionCombinada, lPrecios: Array<any>, bEsAcumulable: boolean) {
        var jResp: any = null;
        try {
            var valores: Array<any> = combi.Accion.Valores;
            valores = valores.sort((a, b) => a.Cantidad - b.Cantidad);
            for(let i = 0; i < lPrecios.length; i++){
                let valorPromo = i < valores.length ? valores[i].Valor : 0
                lPrecios[i].PUNITNETO = +lPrecios[i].PUNITNETO - ((+lPrecios[i].PUNITNETO) * ((+valorPromo) / 100));
                lPrecios[i].Aplicado = true;
            }

            if (lPrecios.length > 0 && lPrecios.find(x => x.Aplicado == true)) {
                this.CalculateTotalPriceFromList(lPrecios, oListEncab, combi, false, bEsAcumulable);
            }

        } catch (ex) {
            jResp = this.GenerarRespuesta(false, null);
            console.log("VerificarClasificacionesProceso");
            console.log(ex);
        }
        return jResp;
    }


    private AplicarPromoByValores(valores: Array<any>, lPrecios: Array<any>, residuoEntrante: number) {
        var iCantidadReal: number = residuoEntrante;// JAGM 20190731 nuevo parametro = lPrecios.length;

        for (var i = 0; i < valores.length; i++) {//JAGM 20190730 se agrega funcionalidad para que se pueda tener varios valores.
            var iCantidadPromo: number = valores[i].Cantidad;
            var valorPromo: number = valores[i].Valor;
            if (iCantidadReal >= iCantidadPromo) { //JAGM 20190426 SE CAMBIA, ANTES ESTABA LA FUNCIONALIDAD DE CANTIDAD REAL VS CANTIDAD PROMOCION.
                var Residuo: number = 0;
                if (iCantidadReal % iCantidadPromo == 0) {
                } else {
                    Residuo = iCantidadReal % iCantidadPromo;
                    this.AplicarPromoByValores(valores, lPrecios, Residuo);
                    iCantidadReal = iCantidadReal - Residuo;
                }
                for (var i = +lPrecios.length - +residuoEntrante; i < +lPrecios.length - +Residuo; i++) {
                    lPrecios[i].PUNITNETO = +lPrecios[i].PUNITNETO - ((+lPrecios[i].PUNITNETO) * ((+valorPromo) / 100));
                    lPrecios[i].Aplicado = true;
                }
                break;
            }
        }
    }


    /**
     * Armar nuevo arreglo, teniendo en cuenta el arreglo entrante. Se recorre de atras hacia adelante y se va creando el nuevo arreglo
     * @param lPrecios 
     * @param residuo 
     */
    public ArmarNuevoArrayDesdeResiduo(lPrecios: Array<any>, residuo) {
        var lPreciosResiduo = new Array<any>();
        try {

            for (var i = lPrecios.length - 1; i > residuo; i--) {
                lPreciosResiduo.push(lPrecios[i]);
            }
        } catch (ex) {
            console.log("ArmarNuevoArratDesdeResiduo");
            console.log(ex);
        }

        return lPreciosResiduo;

    }


    /**
     * Validar promociones por procesos, teniendo en cuenta la informacion del M3 procesos
     * @param oM3Procesos M3 Procesos Objeto, con la informacion de todos los M3Procesos
     * @param condicion Objeto con informacion de condicion
     * @param jAdicionales JSON de informacion adicional
     */
    public VerificarInfoProceso(oM3Procesos: M3Procesos, condicion: M3CONDIPROMO, jAdicionales) {
        var jResp: any;
        if (oM3Procesos[condicion.Concepto] && this.operators[jAdicionales.ROOT.Estructura.Operacion](oM3Procesos[condicion.Concepto], condicion.Valor.trim())) {
            jResp = this.GenerarRespuesta(true, jAdicionales);

        } else {
            jResp = this.GenerarRespuesta(false, null);
        }
        return jResp;
    }

    /**
     * Valida si el proceso tiene una forma de pago que cumpla con la condicion entrante, hace un  pass true, la logica se hace desde la forma de pago
     * @param oM3Procesos 
     * @param condicion 
     * @param jAdicionales 
     */
    public VerificarProcesoFormaPago(oM3Procesos: M3Procesos, condicion: M3CONDIPROMO, jAdicionales) {
        let jResp = this.GenerarRespuesta(true, jAdicionales);
        jResp["FormaPago"] = true;
        return jResp;
    }

    /**
     * Validar promociones por procesos, teniendo en cuenta la informacion del M3 procesos
     * @param oM3Procesos M3 Procesos Objeto, con la informacion de todos los M3Procesos
     * @param condicion Objeto con informacion de condicion
     * @param jAdicionales JSON de informacion adicional
     */
    public VerificarInfoProducto(oM3PrdGeneral: M3PrdGeneral, condicion: M3CONDIPROMO, jAdicionales) {
        try {
            var jResp: any;
            if (this.operators[jAdicionales.ROOT.Estructura.Operacion](oM3PrdGeneral[condicion.Concepto], condicion.Valor.trim())) {
                jResp = this.GenerarRespuesta(true, jAdicionales);
            } else {
                jResp = this.GenerarRespuesta(false, null);
            }

        } catch {
            jResp = this.GenerarRespuesta(false, null);
        }
        return jResp;

    }


    /**
     * Verificar informacion de producto agrupado.
     * @param oTypeM3PrdGrp 
     * @param condicion 
     * @param jAdicionales 
     */
    public VerificarInfoProductoPRDGRP(oTypeM3PrdGrp: TypeM3PrdGrp, condicion: M3CONDIPROMO, jAdicionales) {
        try {
            var jResp: any;
            if (this.operators[jAdicionales.ROOT.Estructura.Operacion](oTypeM3PrdGrp[condicion.Concepto], condicion.Valor.trim())) {
                jResp = this.GenerarRespuesta(true, jAdicionales);
            } else {
                jResp = this.GenerarRespuesta(false, null);
            }

        } catch {
            jResp = this.GenerarRespuesta(false, null);
        }
        return jResp;

    }


    /**
     * Verificar informacion adicional, esta informacion adicional esta en una variable global: goDataAdicional
     * @param condicion Objeto con informacion de condicion
     * @param jAdicionales JSON de informacion adicional
     */
    public VerificarInfoAdicional(condicion: M3CONDIPROMO, jAdicionales) {
        var jResp: any;
        if (this.goDataAdicional[condicion.Concepto] !== undefined && this.operators[jAdicionales.ROOT.Estructura.Operacion](this.goDataAdicional[condicion.Concepto], condicion.Valor.trim())) {
            jResp = this.GenerarRespuesta(true, jAdicionales);
        } else {
            if (jAdicionales.ROOT.Estructura.Operacion == "MOD" && +this.goDataAdicional[condicion.Concepto] > +condicion.Valor) {
                jResp = this.GenerarRespuesta(true, jAdicionales);
            } else {
                jResp = this.GenerarRespuesta(false, null);
            }
        }
        return jResp;
    }

    /**
     * Verificar informacion contra usuario data.
     * @param condicion 
     * @param jAdicionales 
     */
    public VerificarInfoUserData(condicion: M3CONDIPROMO, jAdicionales) {
        var jResp: any;
        if (this.goDataUser.UsuarioSistema[condicion.Concepto] !== undefined && this.operators[jAdicionales.ROOT.Estructura.Operacion](this.goDataUser.UsuarioSistema[condicion.Concepto], condicion.Valor.trim())) {
            jResp = this.GenerarRespuesta(true, jAdicionales);

        } else if (this.goDataUser.UsuarioSistema[condicion.Concepto] && this.goDataUser.UsuarioSistema[condicion.Concepto].includes(',')) {
            for (const element of this.goDataUser.UsuarioSistema[condicion.Concepto].split(',')) {
                if (this.operators[jAdicionales.ROOT.Estructura.Operacion](element, condicion.Valor.trim())) {
                    return this.GenerarRespuesta(true, jAdicionales);
                }
            }
            return this.GenerarRespuesta(false, null);
        }
        else {
            jResp = this.GenerarRespuesta(false, null);
        }
        return jResp;
    }

    //Verificar contra el detalle de la condiciÃ³n
    public VerificacionM3DetalleCondicion(oM3Procesos: M3Procesos, oTypeM3PrdGrp: TypeM3PrdGrp, oM3Ubicacion: M3Ubicacion,
        detCondiciones: Array<M3DETCONDIPROMO>, conceptoCondicion: string, jAdicionalesCondicion) {
        var jResp;
        var odetCondicionesFinded;
        switch (conceptoCondicion.trim()) {
            case "PRD_SKP1":

                odetCondicionesFinded = detCondiciones.find(det => this.operators[jAdicionalesCondicion.ROOT.Estructura.Operacion](det.Valor, oTypeM3PrdGrp.SKP1));
                jResp = this.ValidarRespuesta(odetCondicionesFinded);
                break;
            case "PRD_SKP1+2":
                odetCondicionesFinded = detCondiciones.find(det => this.operators[jAdicionalesCondicion.ROOT.Estructura.Operacion](det.Valor, oTypeM3PrdGrp.SKP1 + oTypeM3PrdGrp.LoM3PrdGeneral[0].SKP2));
                jResp = this.ValidarRespuesta(odetCondicionesFinded);
                break;
            case "PRD_SKU":
                odetCondicionesFinded = detCondiciones.find(det => this.operators[jAdicionalesCondicion.ROOT.Estructura.Operacion](det.Valor.toString(), oTypeM3PrdGrp.LoM3PrdGeneral[0].SKU.toString()));

                jResp = this.ValidarRespuesta(odetCondicionesFinded);
                break;
            case "PRD_DISP":
                odetCondicionesFinded = detCondiciones.find(det => this.operators[jAdicionalesCondicion.ROOT.Estructura.Operacion](oTypeM3PrdGrp.LoM3PrdGeneral[0].DISPONIBLE.toString(), det.Valor.toString()));

                jResp = this.ValidarRespuesta(odetCondicionesFinded);
                break;
            case "PRD_TIPO":
                odetCondicionesFinded = detCondiciones.find(det => this.operators[jAdicionalesCondicion.ROOT.Estructura.Operacion](det.Valor.toString(), oTypeM3PrdGrp.TIPO.toString()));

                jResp = this.ValidarRespuesta(odetCondicionesFinded);

            case "PER_PROCESO"://* Solo valida una detCondicion
                let perXProceso: M3PerXProceso;
                odetCondicionesFinded = undefined;
                perXProceso = oM3Procesos.M3PerXProceso.find(x => x.TipoPersona == detCondiciones[0].Valor.toString())
                if (jAdicionalesCondicion.ROOT.Estructura.Operacion == "EN" && perXProceso) {
                    odetCondicionesFinded = detCondiciones[0];
                } else if (jAdicionalesCondicion.ROOT.Estructura.Operacion == "DIFF" && !perXProceso) {
                    odetCondicionesFinded = detCondiciones[0];
                }
                jResp = this.ValidarRespuesta(odetCondicionesFinded);
                break;
            case "ALMACEN":
                odetCondicionesFinded = detCondiciones.find(det => this.operators[jAdicionalesCondicion.ROOT.Estructura.Operacion](det.Valor.toString(), oM3Ubicacion.IDUbicacion.toString()));
                jResp = this.ValidarRespuesta(odetCondicionesFinded);
                break;
            case "HORARIO_HORA":
                var oTimeNow: Date = new Date();
                odetCondicionesFinded = detCondiciones.find(det => this.operators[jAdicionalesCondicion.ROOT.Estructura.Operacion](det.Valor.toString(), oTimeNow.getHours().toString()));
                jResp = this.ValidarRespuesta(odetCondicionesFinded);
                break;
            case "LoM3PrdAdicionales":
                if (jAdicionalesCondicion.ROOT.Estructura.Concepto !== undefined) {
                    try {
                        var VlrAdi = oTypeM3PrdGrp.LoM3PrdAdicionales.find(adi => adi.ATRIBUTO == jAdicionalesCondicion.ROOT.Estructura.Concepto).VALOR

                        odetCondicionesFinded = detCondiciones.find(det => this.operators[jAdicionalesCondicion.ROOT.Estructura.Operacion](det.Valor.toString(), VlrAdi.toString()));
                        jResp = this.ValidarRespuesta(odetCondicionesFinded);
                    } catch {
                        jResp = this.ValidarRespuesta(null);
                    }
                } else {
                    jResp = this.ValidarRespuesta(null);
                }
                break;
            default:
                //Procesos
                switch (conceptoCondicion.split("_")[0].trim()) {
                    case "PROC":
                        var property = conceptoCondicion.split("_")[1].trim();
                        odetCondicionesFinded = detCondiciones.find(det => this.operators[jAdicionalesCondicion.ROOT.Estructura.Operacion](det.Valor, oM3Procesos[property]));
                        jResp = this.ValidarRespuesta(odetCondicionesFinded);
                        break;
                    case "USER":
                        var property = conceptoCondicion.split("_")[1].trim();
                        odetCondicionesFinded = detCondiciones.find(det => this.operators[jAdicionalesCondicion.ROOT.Estructura.Operacion](det.Valor, this.goDataUser.UsuarioSistema[property]));
                        jResp = this.ValidarRespuesta(odetCondicionesFinded);
                        break;
                    default:
                        console.log("No Entro por Detalle!");
                        jResp = this.GenerarRespuesta(false, null);
                        break;
                }
                break;

        }
        return jResp;
    }




    //Validar respuesta, con objeto a validar
    public ValidarRespuesta(objectValidate) {
        var jResp;
        var jAdicionales;
        if (objectValidate) {
            jAdicionales = JSON.parse(objectValidate.JAdicionales);
            //JAGM 20190625 Agregar seccion de validaciones.
            var bResp = this.ValidacionesByJAdicionales(jAdicionales)
            if (bResp) {
                //Se envia en adicionales, el json de la informacion encontrada del detalle.
                jResp = this.GenerarRespuesta(true, jAdicionales);
            } else {
                jResp = this.GenerarRespuesta(false, null);
            }

        } else {
            jResp = this.GenerarRespuesta(false, null);
        }
        return jResp;
    }

    /**
     * Validar reglas configuradas desde JSON de Adicionales
     * @param jAdicionales 
     */
    public ValidacionesByJAdicionales(jAdicionales: any) {
        var bResp = true;
        try {
            //console.log("***********************************ValidacionesByJAdicionales")
            //console.log(jAdicionales)
            if (jAdicionales.ROOT.VALIDACIONES && jAdicionales.ROOT.VALIDACIONES.TIPO) {
                switch (jAdicionales.ROOT.VALIDACIONES.TIPO) {
                    case "VIGENCIA":
                        bResp = this.ValidarVigencia(jAdicionales.ROOT.VALIDACIONES.VAL1, jAdicionales.ROOT.VALIDACIONES.VAL2);
                        break;
                    default:
                        break;
                }
            }
        } catch (ex) {
            console.log("***********************************Error");
            console.log(ex);
        }
        return bResp;
    }

    public ValidarVigencia(val1: Date, val2: Date) {

        var FechaActual = new Date();
        // console.log(val1)
        // console.log(val2)

        // var dVal1 = new Date(val1);
        // var dVal2 = new Date(val2);

        // console.log(dVal1)
        // console.log(dVal2)


        var nFechaActual: number = +this.GetFechaNumber(FechaActual); //+(FechaActual.getFullYear() + "" + FechaActual.getMonth() + "" + FechaActual.getDate());
        var nVal1: number = +this.GetFechaNumber(val1); //+(dVal1.getFullYear() + "" + dVal1.getMonth() + "" + (+dVal1.getDate() + 1) );
        var nVal2: number = +this.GetFechaNumber(val2) //+(dVal2.getFullYear() + "" + dVal2.getMonth() + "" + (+dVal2.getDate() + 1) );
        if (nFechaActual >= nVal1 && nFechaActual <= nVal2) {
            return true;
        } else {
            return false;
        }

    }

    public GetFechaNumber(date: Date) {
        var d = moment(date).format('YYYYMMDD');
        return d;
    }


    //Validar accion, si no tiene cargada una. Esta accion se carga jerarquicamente.
    public ValidarAccion(jResp, jAdicionales) {
        var jsonAdic = JSON.parse(jAdicionales);
        if (jResp.Accion == null && jsonAdic.ROOT.Accion !== undefined) {
            jResp.Accion = jsonAdic.ROOT.Accion;
        }
    }

    //Retomar informaciÃ³n 
    public RetomarValoresPromocion(oM3ENCPROMO: M3ENCPROMO, jResp) {
        jResp.Promocion = {};
        jResp.Promocion.Nombre = oM3ENCPROMO.Nombre;
        jResp.Promocion.ID = oM3ENCPROMO.IdPromocion;
        //Si no tuvo ninguna accion
        if (jResp.Accion == null) {
            jResp.Accion = { "Tipo2": oM3ENCPROMO.Tipo2, "Tipo": oM3ENCPROMO.Tipo };
        } else {
            /// Retomar desde el encabezado promo, si no existe el tipo y Tipo2
            if (!jResp.Accion.Tipo2) {
                jResp.Accion.Tipo2 = oM3ENCPROMO.Tipo2;
            }
            if (!jResp.Accion.Tipo) {
                jResp.Accion.Tipo = oM3ENCPROMO.Tipo;
            }
        }
    }
    //--------------------------> Fin Obtener informacion de promocion <--------------------------------

    //--------------------------> Inicio Procesamiento de promocion <--------------------------------


    //Procesamiento de promociÃ³n, teniendo en cuenta la informacion del producto a aplicar la promocion y las promociones a aplicar
    public ProcesarPromocion(JPromociones: Array<any>, oTypeM3PrdGrp: TypeM3PrdGrp, oM3ENCPROMO: Array<M3ENCPROMO>): PromocionProcesada {
        var oPromocionProcesada = new PromocionProcesada();

        oPromocionProcesada.PrecioTotal = oTypeM3PrdGrp.LoM3PrdGeneral[0].LoM3PrdLista.PRECIO;
        oPromocionProcesada.PrecioTotalPromocion = 0;

        return this.ProcesarPromoGeneral(JPromociones, oTypeM3PrdGrp.LoM3PrdGeneral[0].LoM3PrdLista.PRECIO, oPromocionProcesada, oM3ENCPROMO);
    }

    /**
     * Procesamiento de promocion que se hacen validas despues de registrar todos los productos.
     * @param JPromociones 
     * @param oM3Procesos 
     */
    public ProcesarPromoAfter(JPromociones: Array<any>, oM3Procesos: M3Procesos, oM3ENCPROMO: Array<M3ENCPROMO>): PromocionProcesada {
        try {
            var oPromocionProcesada = new PromocionProcesada();

            oPromocionProcesada.PrecioTotal = oM3Procesos.ValorNeto;
            oPromocionProcesada.PrecioTotalPromocion = 0;
            return this.ProcesarPromoGeneral(JPromociones, oM3Procesos.ValorNeto, oPromocionProcesada, oM3ENCPROMO);
        } catch {
            return null;
        }

    }

    /**
     * Procesamiento de promocion en general
     * @param JPromociones 
     * @param nPrecio 
     * @param oPromocionProcesada 
     */
    public ProcesarPromoGeneral(JPromociones: Array<any>, nPrecio: number, oPromocionProcesada: PromocionProcesada, oM3ENCPROMO: Array<M3ENCPROMO>): PromocionProcesada {
        var oPromocionesAsociadas: PromocionesAsociadas;
        var oListaPromosAsoc = new Array<PromocionesAsociadas>();

        for (var _i = 0; _i < JPromociones.length; _i++) {
            //JPromociones.forEach(promocion => {
            var promocion = JPromociones[_i];
            oPromocionesAsociadas = this.ProcesarPromoByTipo(promocion, nPrecio, oPromocionProcesada, oM3ENCPROMO);
            if (oPromocionesAsociadas) {
                oListaPromosAsoc.push(oPromocionesAsociadas);
            }

        }
        this.ValidarMejorPromocion(oListaPromosAsoc, oPromocionProcesada, nPrecio);

        // if (oPromocionesAsociadas != null) {
        //     oPromocionProcesada.ListPromocionesAsociadas.push(oPromocionesAsociadas);
        //     oPromocionProcesada.PrecioTotal = Math.round(((+oPromocionProcesada.PrecioTotal) - oPromocionesAsociadas.Valor) * 100) / 100;
        //     oPromocionProcesada.PrecioTotalPromocion = Math.round(((+oPromocionProcesada.PrecioTotalPromocion) + oPromocionesAsociadas.Valor) * 100) / 100;
        //     oPromocionProcesada.ValorTotalMonedero += oPromocionesAsociadas.ValorMonedero;
        // }

        if (oPromocionProcesada.PrecioTotal < 0) {
            oPromocionProcesada.PrecioTotal = 0;
        }
        //FS 20190725 Redodneo de los valores totales
        // oPromocionProcesada.PrecioTotal = oPromocionProcesada.PrecioTotal;
        // oPromocionProcesada.PrecioTotalPromocion = oPromocionProcesada.PrecioTotalPromocion;
        return oPromocionProcesada;
    }

    /**
     * Validacion de mejor opcion, teniendo en cuenta las promociones procesadas.
     * @param oListaPromosAsoc Lista de promociones procesadas
     * @param oPromocionProcesada Promocion procesada, que retornarÃ¡ a flujo.
     */
    public ValidarMejorPromocion(oListaPromosAsoc: Array<PromocionesAsociadas>, oPromocionProcesada: PromocionProcesada, precio: number): PromocionProcesada {
        let promoAsociadaRestringido = oListaPromosAsoc.find(x => x.Tipo == "RESTRICCION");
        //Si el producto esta restringido le da mayor prioridad a esta promociÃ³n
        if (!promoAsociadaRestringido) {
            //1. Suma de todas las promociones Acumulables
            //var dPromoACM: number = 0;
            //dPromoACM = this.GetMaxXRegla(oListaPromosAsoc, "ACM", oPromocionProcesada);
            let dPromoEXC = this.GetMaxXRegla(oListaPromosAsoc, "EXC", oPromocionProcesada);
            let dPromoACMDIN = this.GetMaxXRegla(oListaPromosAsoc, "ACMDIN", oPromocionProcesada);
            //Promociones No Acumulables

            if (dPromoACMDIN < dPromoEXC) {
                this.aplicaPromoEXC(oListaPromosAsoc, oPromocionProcesada, dPromoEXC);
            }
            else {
                this.aplicaPromoACMDIN(oListaPromosAsoc, oPromocionProcesada, dPromoACMDIN);
            }
            oPromocionProcesada.ListPromocionesAsociadas = oListaPromosAsoc//.push(oListaPromosAsoc.find(x => x.Valor == dPromoEXC));

            //Recorrer todas las promociones Acumulables

            for (const promo of oListaPromosAsoc.filter(x => x.Regla.trim().toUpperCase() == "ACM" && !x.flags.formaPago)) {
                promo.Aplicada = true;
                if (promo.ValorPorcentaje > 0) {
                    let nuevoValorDescuento = ((+oPromocionProcesada.PrecioTotal) * promo.ValorPorcentaje / 100);
                    oPromocionProcesada.PrecioTotal = (+oPromocionProcesada.PrecioTotal) - nuevoValorDescuento;
                    oPromocionProcesada.PrecioTotalPromocion = (+oPromocionProcesada.PrecioTotalPromocion) + nuevoValorDescuento;
                }
                else {
                    oPromocionProcesada.PrecioTotal = ((+oPromocionProcesada.PrecioTotal) - promo.Valor);
                    oPromocionProcesada.PrecioTotalPromocion = ((+oPromocionProcesada.PrecioTotalPromocion) + promo.Valor);
                }
                oPromocionProcesada.ValorTotalMonedero += promo.ValorMonedero;
            }

            ///////FUNCIONALIDAD PRODRIA FUNCIONAR MÃS ADELANTE, SI SE QUIERE AGRUPAR LAS PROMOCIONES ACM Y EXC
            // if(dPromoACM == 0 && dPromoEXC == 0){
            //     throw new Error('No se encontraron promociones');
            // }else{
            //     if(dPromoACM > dPromoEXC){
            //         //Gana promociones acumulativas.
            //         oListaPromosAsoc.filter(x => x.Regla.trim().toUpperCase() == "ACM").forEach(x => x.Aplicada = true); // Marcacion de promocion aplicada
            //         oPromocionProcesada.ListPromocionesAsociadas = oListaPromosAsoc;//.filter(x => x.Regla.trim().toUpperCase() == "ACM")
            //         oPromocionProcesada.PrecioTotal = Math.round(((+oPromocionProcesada.PrecioTotal) - dPromoACM) * 100) / 100;
            //         oPromocionProcesada.PrecioTotalPromocion = Math.round(((+oPromocionProcesada.PrecioTotalPromocion) + dPromoACM) * 100) / 100;
            //         oPromocionProcesada.ValorTotalMonedero += oListaPromosAsoc.filter(x => x.Regla.trim().toUpperCase() == "ACM").reduce((acc, cur) => (acc) + (+cur.ValorMonedero), 0);
            //     }else{
            //         //Gana promociones excluyentes.
            //         oListaPromosAsoc.find(x => x.Valor == dPromoEXC).Aplicada = true; // Marcacion de promocion aplicada
            //         oPromocionProcesada.ListPromocionesAsociadas = oListaPromosAsoc//.push(oListaPromosAsoc.find(x => x.Valor == dPromoEXC));
            //         oPromocionProcesada.PrecioTotal = Math.round(((+oPromocionProcesada.PrecioTotal) - dPromoEXC) * 100) / 100;
            //         oPromocionProcesada.PrecioTotalPromocion = Math.round(((+oPromocionProcesada.PrecioTotalPromocion) + dPromoEXC) * 100) / 100;
            //         oPromocionProcesada.ValorTotalMonedero += oListaPromosAsoc.find(x => x.Valor == dPromoEXC).ValorMonedero;
            //     }
            // }
        }
        else {
            oPromocionProcesada.ListPromocionesAsociadas = new Array<PromocionesAsociadas>(promoAsociadaRestringido);
            oPromocionProcesada.PrecioTotal = 0;
            oPromocionProcesada.PrecioTotalPromocion = 0;
            oPromocionProcesada.ValorTotalMonedero = 0;
        }


        return oPromocionProcesada;
    }

    aplicaPromoEXC(oListaPromosAsoc: Array<PromocionesAsociadas>, oPromocionProcesada: PromocionProcesada, valorPromoEXC: number) {
        let promoExc: PromocionesAsociadas;
        if (valorPromoEXC > 0) {
            promoExc = oListaPromosAsoc.find(x => x.Valor == valorPromoEXC || x.ValorMonedero == valorPromoEXC);
            promoExc.Aplicada = true; // Marcacion de promocion aplicada
            oPromocionProcesada.PrecioTotal = ((+oPromocionProcesada.PrecioTotal) - promoExc.Valor);
            oPromocionProcesada.PrecioTotalPromocion = ((+oPromocionProcesada.PrecioTotalPromocion) + promoExc.Valor);
            oPromocionProcesada.ValorTotalMonedero += promoExc.ValorMonedero;
        }
    }
    aplicaPromoACMDIN(oListaPromosAsoc: Array<PromocionesAsociadas>, oPromocionProcesada: PromocionProcesada, valorPromoACMDIN: number) {
        if (valorPromoACMDIN > 0) {
            for (let promo of oListaPromosAsoc.filter(x => x.Regla == "ACMDIN")) {
                promo.Aplicada = true;
                oPromocionProcesada.ValorTotalMonedero += promo.ValorMonedero;
            }
            oPromocionProcesada.PrecioTotal = ((+oPromocionProcesada.PrecioTotal) - valorPromoACMDIN);
            oPromocionProcesada.PrecioTotalPromocion = ((+oPromocionProcesada.PrecioTotalPromocion) + valorPromoACMDIN);

        }
    }

    /**
     * Obtener el maximo valor segun la regla a comparar
     * @param oListaPromosAsoc 
     * @param sRegla 
     */
    public GetMaxXRegla(oListaPromosAsoc: Array<PromocionesAsociadas>, sRegla: string, oPromocionProcesada: PromocionProcesada) {
        var result: number = 0;
        try {
            switch (sRegla) {
                // case "ACM":
                //     result = oListaPromosAsoc.filter(x => x.Regla.trim().toUpperCase() == sRegla && !x.flags.formaPago).reduce((acc, cur) => (acc) + (+cur.Valor), 0);
                //     break;
                case "ACMDIN":
                    let precioActual = oPromocionProcesada.PrecioTotal;
                    let valorTotalDescuento = 0;
                    for (const promo of oListaPromosAsoc.filter(x => x.Regla.trim().toUpperCase() == "ACMDIN" && (!x.flags.formaPago || x.Tipo == "MONEDERO"))) {
                        if (promo.ValorPorcentaje > 0) {
                            let nuevoValorDescuento = (precioActual * promo.ValorPorcentaje / 100);
                            precioActual -= nuevoValorDescuento;
                            valorTotalDescuento += nuevoValorDescuento;
                        }
                        else {
                            precioActual -= promo.Valor;
                            valorTotalDescuento += promo.Valor;
                        }
                    }
                    result = valorTotalDescuento;
                    break;
                case "EXC":
                    result = Math.max.apply(Math, oListaPromosAsoc.filter(x => x.Regla.trim().toUpperCase() == sRegla && (!x.flags.formaPago || x.Tipo == "MONEDERO")).map(function (o) { return o.Valor > o.ValorMonedero ? o.Valor : o.ValorMonedero; }))
                    break;
            }
        } catch {
        }
        return result;
    }


    //Procesar promocion segun el tipo 
    public ProcesarPromoByTipo(promocion: any, Precio: number, oPromocionProcesada: PromocionProcesada, oM3ENCPROMO: Array<M3ENCPROMO>): PromocionesAsociadas {
        try {
            var Accion;
            var oPromocionesAsociadas = new PromocionesAsociadas();
            if (promocion.Accion != null && promocion.Promocion != undefined) {
                oPromocionesAsociadas.IDPromocion = promocion.Promocion.ID;
                oPromocionesAsociadas.Nombre = promocion.Promocion.Nombre;
                Accion = promocion.Accion;
                if (Accion.Regla) {
                    oPromocionesAsociadas.Regla = Accion.Regla;
                } else {
                    oPromocionesAsociadas.Regla = "EXC";
                }

                oPromocionesAsociadas.Tipo = Accion.Tipo2;

                switch (Accion.Tipo2.trim().toUpperCase()) {
                    case "DTO_%":
                        oPromocionesAsociadas.ListObsSKU = null;
                        oPromocionesAsociadas.ValorPorcentaje = +Accion.Valor
                        oPromocionesAsociadas.Valor = (+Precio) * ((+Accion.Valor) / 100);
                        break;
                    case "DTO_VALOR":
                        oPromocionesAsociadas.ListObsSKU = null;
                        oPromocionesAsociadas.Valor = Accion.Valor;
                        break;
                    case "DTO_EXACT":
                        oPromocionesAsociadas.ListObsSKU = null;
                        oPromocionesAsociadas.Valor = (+Precio) - (+Accion.Valor);
                        break;
                    case "OBSEQ":
                        oPromocionesAsociadas.Valor = 0;
                        oPromocionesAsociadas.ListObsSKU = Accion.OBSEQUIOS;
                        oPromocionesAsociadas.ReglaObseq = Accion.ReglaObseq;
                        this.ValidarCantidadObsequios(oM3ENCPROMO, Accion.OBSEQUIOS, oPromocionesAsociadas);
                        //validar cantidad vs cantidad de obsquios
                        break;
                    case "MONEDERO":
                        oPromocionesAsociadas.ListObsSKU = null;
                        oPromocionesAsociadas.Valor = 0;
                        oPromocionesAsociadas.ValorMonedero = +Accion.Valor;
                        //FS 20190827 Ya no se guarda el valor total del monedero si no unicamente el porcentaje... oPromocionesAsociadas.ValorMonedero = (+oPromocionProcesada.PrecioTotal) * ((+Accion.Valor) / 100);
                        break;
                    case "CUPON":
                        oPromocionesAsociadas.Valor = 0;
                        oPromocionesAsociadas.ListObsSKU = null;
                        oPromocionesAsociadas.IdCupon = Accion.Valor;
                        break;
                    case "RESTRICCION_PAGO":
                    case "RESTRICCION":
                        oPromocionesAsociadas.Valor = 0;
                        oPromocionesAsociadas.ListObsSKU = null;
                        oPromocionesAsociadas.Tipo = Accion.Tipo2.trim().toUpperCase();
                        break;
                    // case "MOD_CANTIDAD":
                    //     //this.AplicarReglaModCantidad(oPromocionesAsociadas, oPromocionProcesada, Accion);
                    //     break;
                    default:
                        if (Accion.Tipo == "COMBINADA") {
                            oPromocionesAsociadas.Valor = 0;
                            oPromocionesAsociadas.ListObsSKU = null;
                            oPromocionesAsociadas.PromocionCombinada = new PromocionCombinada();
                            oPromocionesAsociadas.PromocionCombinada.IdPromocionCombinada = oPromocionesAsociadas.IDPromocion;
                            oPromocionesAsociadas.PromocionCombinada.Tipo2 = Accion.Tipo2.trim().toUpperCase();
                            oPromocionesAsociadas.PromocionCombinada.Nombre = oPromocionesAsociadas.Nombre;
                            oPromocionesAsociadas.PromocionCombinada.Accion = Accion;

                            this.ValidarCamposAdicionales(oM3ENCPROMO, oPromocionesAsociadas.PromocionCombinada, promocion);
                        } else {
                            oPromocionesAsociadas = null;
                        }
                        break;
                }

                if (promocion.FormaPago) {
                    oPromocionesAsociadas.flags.formaPago = true;
                }
            } else {
                return null;
            }
            return oPromocionesAsociadas;
        } catch (ex) {
            console.log(ex);
            return null;
        }
    }

    public ValidarCantidadObsequios(oM3ENCPROMO: Array<M3ENCPROMO>,
        obsequios: Array<any>, oPromocionesAsociadas: PromocionesAsociadas) {
        try {
            var promo: M3ENCPROMO;
            var ValorCantPRD: number = -1;
            var ValorCantPRDReal: number = this.goDataAdicional.dCantidad;
            promo = oM3ENCPROMO.find(x => x.IdPromocion == oPromocionesAsociadas.IDPromocion);
            promo.M3CONDIAGRUPACION.forEach(x => {
                ValorCantPRD = +x.M3CONDIPROMO.find(x => x.Concepto == "dCantidad").Valor;
            });

            if (ValorCantPRD != -1) {
                //La cantidad ya no se asigan desde aca
                // for (var i = 0; i < obsequios.length; i++) {
                //     if (obsequios[i].Cantidad) {
                //         obsequios[i].Cantidad = Math.floor(ValorCantPRDReal / ValorCantPRD) * obsequios[i].Cantidad;
                //     }
                // }
                oPromocionesAsociadas.ListObsSKU = obsequios;
            }


        } catch (ex) {

        }
    }

    /**
     * Validar campos adicionales en promociones
     * @param oM3ENCPROMO 
     * @param oPromocionCombinada 
     * @param promocion 
     */
    public ValidarCamposAdicionales(oM3ENCPROMO: Array<M3ENCPROMO>, oPromocionCombinada: PromocionCombinada, promocion: any) {
        switch (oPromocionCombinada.Tipo2) {
            case "OBSEQ_CIERRE":
                //Agregar Cantidad.
                var promo: M3ENCPROMO;
                var sValorCantidad: string = "1";
                promo = oM3ENCPROMO.find(x => x.IdPromocion == oPromocionCombinada.IdPromocionCombinada);
                promo.M3CONDIAGRUPACION.forEach(x => {
                    sValorCantidad = x.M3CONDIPROMO.find(x => x.Concepto == "dCantidad").Valor;
                });
                oPromocionCombinada.Accion.CantidadObsq = sValorCantidad;
                break;
            case "XCARACTERISTICA":
                // var promo: M3ENCPROMO;
                // promo = oM3ENCPROMO.find(x => x.IdPromocion == oPromocionCombinada.IdPromocionCombinada);
                // var jAdic:any = JSON.parse(promo.JAdicionales);
                // oPromocionCombinada.Accion.Clasificacion = jAdic.ROOT.Accion.Caracteristica;
                break;
            case "COMBO":
                var promo: M3ENCPROMO;
                promo = oM3ENCPROMO.find(x => x.IdPromocion == oPromocionCombinada.IdPromocionCombinada);
                if (!oPromocionCombinada.Accion.NumCondiciones) {
                    oPromocionCombinada.Accion.NumCondiciones = promo.M3CONDIAGRUPACION[0].M3CONDIPROMO.length;
                }
                if (promocion.IDCondicion) {
                    oPromocionCombinada.Accion.IdCondicion = promocion.IDCondicion
                }
                break;
            default:
                break;
        }
    }

    //--------------------------> Fin Procesamiento de promocion <--------------------------------


    //--------------------------> Inicio Procesamiento Combinada <--------------------------------

    //Procesar promociones combinadas
    public ProcesarCombinada(oM3Procesos: M3Procesos) {
        try {
            this.PromoCombinadasV2(oM3Procesos);
            return oM3Procesos;
        } catch (ex) {
            console.log("ProcesarCombinada");
            console.log(ex);
            return oM3Procesos;
        }

    }

    /////////////////////////////V2 COMBINADA
    /**
   * Procesamiento de promociones combinadas, teniendo en cuenta la lista de promociones combinadas de M3Procesos
   * @param ioM3Proceso Objeto M3 Procesos, el cual se recorrerÃ¡ la informacion de lista de promociones combinadas
   */
    public PromoCombinadasV2(ioM3Proceso: M3Procesos) {
        var oListEncab: Array<M3PEncItems>;
        let encConLaCantidadOriginal = _.cloneDeep(ioM3Proceso.M3ENC);

        if (ioM3Proceso.PromosCombinadas === undefined) {
            this.GetCombinadasFromDinamicas(ioM3Proceso);
        }

        for (var i = 0; i < ioM3Proceso.PromosCombinadas.length; i++) {
            this.AddDinamicaProcesoCombinadas(ioM3Proceso);
            var combi: PromocionCombinada = ioM3Proceso.PromosCombinadas[i];
            var esAcumulable = this.GetEsAcumulablePromo(combi)
            ///Obtener todos los Encabezados que aplican a la promocion a la que se esta iterando
            oListEncab = this.GetEncabezadoByCombi(combi, ioM3Proceso);
            switch (combi.Tipo2) {
                case "MOD_CANTIDAD":
                    var lPrecios = this.ProcesarPromoCombyByListEnc(oListEncab, esAcumulable);
                    //Esta promocion es: 3 gaseosas por $500
                    this.AplicarReglaModCantidad(lPrecios, oListEncab, combi, esAcumulable);
                    break;
                case "OBSEQ_CIERRE":
                    this.ProcesarPromoObsqCierre(oListEncab, combi, ioM3Proceso, esAcumulable);
                    break;
                case "OBSEQ_SUMTOTAL":
                    this.procesarObseqSumTotal(oListEncab, combi, ioM3Proceso);
                    break;
                case "XCARACTERISTICA":
                    var lPrecios = this.ProcesarPromoCombyByListEnc(oListEncab, esAcumulable);
                    this.VerificarClasificacionesProceso(oListEncab, combi, lPrecios, esAcumulable);
                    break;
                case "XCARACTERISTICAPARCIAL":
                    this.ordenarListaEnc(oListEncab, esAcumulable);
                    var lPrecios = this.ProcesarPromoCombyByListEnc(oListEncab, esAcumulable);
                    this.procesarCaracteristicaParcial(oListEncab, combi, lPrecios, esAcumulable);
                    break;
                case "COMBO":
                    let aplCombo = true;
                    while (aplCombo) {
                        var lPrecios = this.ProcesarPromoCombyByListEnc(oListEncab, esAcumulable);
                        aplCombo = this.PromocionCombinadaCombo(lPrecios, oListEncab, combi, esAcumulable, ioM3Proceso);
                    }
                    break;
                case "DTO_VALORTOTAL":
                    var lPrecios = this.ProcesarPromoCombyByListEnc(oListEncab, esAcumulable);
                    this.AplReglaCombValorTotal(lPrecios, oListEncab, combi, esAcumulable);
                    break;
                case "PROD_APLDESC":
                    this.procesarProductoAplDesc(oListEncab, combi, ioM3Proceso, esAcumulable);
                    break;
                default:
                    //Esta promocion es para 2x1, 3x1, 4x2, ...
                    if (oListEncab && oListEncab.length > 0) {
                        var lPrecios = this.ProcesarPromoCombyByListEnc(oListEncab, esAcumulable);
                        this.CalcularPromocionesByListaPrec(lPrecios, oListEncab, combi, esAcumulable);
                    }
                    break;
            }
        }
        //Se reestablece la cantidad original para que no se quede en un buvle infinito
        for (const oM3PEncOriginales of encConLaCantidadOriginal) {
            let cantidadOriginal = oM3PEncOriginales.M3DET.find(d => d.NombreConcepto == "CANTIDAD").Valor;
            let productoActual = ioM3Proceso.M3ENC.find(x => x.ID == oM3PEncOriginales.ID);
            productoActual.M3DET.find(d => d.NombreConcepto == "CANTIDAD").Valor = cantidadOriginal;
        }

        return ioM3Proceso;
    }

    public ordenarListaEnc(olistaEnc: M3PEncItems[], esAcumulable){
        if(esAcumulable) olistaEnc.sort((a,b)=> (+b.M3DET.find(x=> x.NombreConcepto == 'PUNITNETO').Valor) - (+a.M3DET.find(x=> x.NombreConcepto == 'PUNITNETO').Valor));
        else olistaEnc.sort((a,b)=> (+b.M3DET.find(x=> x.NombreConcepto == 'PUNIT').Valor) - (+a.M3DET.find(x=> x.NombreConcepto == 'PUNIT').Valor));

    }

    public AplReglaCombValorTotal(lPrecios: Array<any>, oListEncab: Array<M3PEncItems>, combi: PromocionCombinada, bEsAcumulable: boolean) {
        var Accion = combi.Accion;
        var cantidadDescPromo: number = +Accion.Valor;
        let precioTotalCompra: number = lPrecios.reduce(function (a, b) { return a + Number(b.PUNITNETO); }, 0);
        console.debug(precioTotalCompra);
        let descAcum = 0;
        let descProdActual;

        for (var i = 0; i < lPrecios.length; i++) {
            descProdActual = (lPrecios[i].PUNITNETO / precioTotalCompra) * cantidadDescPromo //40
            descAcum += descProdActual;
            lPrecios[i].Aplicado = true;
            lPrecios[i].PUNITNETO = lPrecios[i].PUNITNETO - descProdActual;
            // if (cantidadDescPromo > 0) {
            //     lPrecios[i].Aplicado = true;
            //     if (lPrecios[i].PUNITNETO < cantidadDescPromo) {
            //         cantidadDescPromo -= lPrecios[i].PUNITNETO;
            //         lPrecios[i].PUNITNETO = 0;
            //     }
            //     else{
            //         lPrecios[i].PUNITNETO -= cantidadDescPromo;
            //         cantidadDescPromo = 0;
            //     }
            // }
            // else {
            //     break;
            // }
        }

        if (cantidadDescPromo > descAcum || cantidadDescPromo < descAcum) {
            //find del ultimo 
            console.debug("Encontre diferencia en promos combinadas: " + cantidadDescPromo + " vs " + descAcum);
            lPrecios[lPrecios.length - 1].PUNITNETO = lPrecios[lPrecios.length - 1].PUNITNETO - (cantidadDescPromo - descAcum);
        }

        if (lPrecios.find(x => x.Aplicado)) {
            console.debug("AplicarReglaModCantidad")
            this.CalculateTotalPriceFromList(lPrecios, oListEncab, combi, true, bEsAcumulable);
        }
    }


    public procesarObseqSumTotal(productosAplicaPromo: M3PEncItems[], combi: PromocionCombinada, oM3Procesos: M3Procesos) {
        let valorPromo = +combi.Accion.Valor;
        let sumaValorProductos = 0;
        let cantidadObsequios = 0;
        let cantidadProductoActual = 1;
        let productosHijosDelCombo: Array<M3PEncItems> = [];
        let productosRevisados = [];
        let oM3RegService = new M3RegService(null, null, null);
        let valorCombo = 0;
        let diferencia = 0;

        for (let encItem of productosAplicaPromo) {
            cantidadProductoActual = 1;
            let pUnitActual = +encItem.M3DET.find(x => x.NombreConcepto == "PUNIT").Valor;
            let cantidadActual = +encItem.M3DET.find(x => x.NombreConcepto == "CANTIDAD").Valor;
            while (cantidadProductoActual <= cantidadActual) {
                sumaValorProductos += pUnitActual;
                cantidadProductoActual++;

                let productoRevisado = productosRevisados.find(x => x.Id == encItem.ID);
                if (productoRevisado) {
                    productoRevisado.Cantidad++;
                }
                else {
                    productosRevisados.push({ Id: encItem.ID, Cantidad: 1 });
                }
                if (sumaValorProductos + diferencia >= valorPromo) {
                    valorCombo += sumaValorProductos;
                    this.agregarProductoAProductosHijosSumTotal(productosHijosDelCombo, oM3Procesos, productosRevisados);
                    cantidadObsequios++;
                    productosRevisados = [];
                    diferencia = sumaValorProductos - valorPromo;
                    sumaValorProductos = 0;
                }
            }
        }
        if (productosHijosDelCombo.length > 0) {
            let productoCombo = oM3RegService.loadM3PEncItemsFromPromocionCombo(oM3Procesos, productosHijosDelCombo, combi.Accion.Codigo, valorCombo, 1);
            oM3RegService.armarListaObsequiosCombiSKU(combi, productoCombo, cantidadObsequios);
            oM3Procesos["oM3RegService"] = oM3RegService;
        }
    }

    agregarProductoAProductosHijosSumTotal(productosHijosDelCombo: Array<M3PEncItems>, oM3Proceso: M3Procesos, productosRevisados) {
        let oM3RegService = new M3RegService(null, null, null);
        let prodHijo: M3PEncItems;

        for (let prodRevisado of productosRevisados) {
            if (prodRevisado) {
                let oM3PEncItems = oM3Proceso.M3ENC.find(x => x.ID == prodRevisado.Id);
                if (oM3PEncItems) {
                    var oM3PDetalleItems: M3PDetalleItems// = new M3PDetalleItems();
                    oM3PDetalleItems = oM3PEncItems.M3DET.find(d => d.NombreConcepto == "CANTIDAD");
                    if (+oM3PDetalleItems.Valor > 0) {
                        oM3PDetalleItems.Valor = (+oM3PDetalleItems.Valor - prodRevisado.Cantidad).toString();

                        prodHijo = _.cloneDeep(oM3PEncItems)
                        oM3RegService.ValoresCalculadosProceso(prodHijo, prodRevisado.Cantidad);
                        productosHijosDelCombo.push(prodHijo);
                        this.agregarAProductosQuitarCombi(oM3Proceso, prodHijo, prodRevisado.Cantidad);
                    }
                }
            }
        }
    }

    getProdutoPromoComboSumTotal(productosEnM3Proceso: Array<M3PEncItems>, oPrecioDelProductoActual): M3PEncItems {
        let oM3PEncItems = productosEnM3Proceso.find(x => x.ID == oPrecioDelProductoActual.ID)
        if (oM3PEncItems) {
            var oM3PDetalleItems: M3PDetalleItems// = new M3PDetalleItems();
            oM3PDetalleItems = oM3PEncItems.M3DET.find(d => d.NombreConcepto == "CANTIDAD");
            if (+oM3PDetalleItems.Valor > 0) {
                oM3PDetalleItems.Valor = (+oM3PDetalleItems.Valor - 1).toString();
                return _.cloneDeep(oM3PEncItems);
            }
        }
        return null;
    }

    /**
     * Lista de precios
     * @param lPrecios 
     * @param oListEncab 
     */
    public GetListaPrecios(lPrecios: Array<any>, oListEncab: Array<M3PEncItems>) {
        var lPreciosFilter = new Array<any>();
        for (var i = 0; i < oListEncab.length; i++) {
            lPrecios.filter(y => y.ID == oListEncab[i].ID).forEach(x => {
                lPreciosFilter.push(x);
            });

        }
        return lPreciosFilter;
    }

    /**
     * Promocion de combo, x productos, y productos, ... n productos 
     * por $1000
     * @param lPrecios 
     * @param oListEncab 
     * @param combi 
     * @param bEsAcumulable 
     */
    public PromocionCombinadaCombo(lPrecios: Array<any>, oListEncab: Array<M3PEncItems>, combi: PromocionCombinada, bEsAcumulable: boolean, ioM3Proceso: M3Procesos): boolean {

        let flagAplicoPromo = false;
        try {
            var nNumeroCondiciones: number = +combi.Accion.NumCondiciones;
            var ValorPromo = +combi.Accion.Valor;
            var ListCondiciones = new Array<Array<any>>();
            var minimoItems: number = 0;
            let porcentajePromo = 0;
            let valorTotalSinPromo = 0;
            let productosHijosDelCombo = new Array<M3PEncItems>();
            let oM3RegService: M3RegService;


            for (var i = 1; i <= nNumeroCondiciones; i++) {
                //Buscar condicion 1.
                var ListPromoCombi: Array<M3PEncItems> = this.BuscarEncByPromoYCond(oListEncab, i.toString(), combi.IdPromocionCombinada.toString());
                ListCondiciones.push(this.GetListaPrecios(lPrecios, ListPromoCombi));
            }

            this.filtrarListaCondicionesCombo(ListCondiciones, oListEncab);
            if (ListCondiciones.length > 0) {
                //Buscar el valor menor de las items agregadas
                minimoItems = ListCondiciones[0].length;
                for (var j = 1; j < ListCondiciones.length; j++) {//Comienza desde 1 porque el 0 ya se valido en la anterior linea
                    var itemsPrecios: Array<any> = ListCondiciones[j];
                    var newMin = itemsPrecios.length;
                    if (newMin < minimoItems) {
                        minimoItems = newMin;
                    }
                }
                //Los combos deben procesarse de a uno para su correcto funcionamiento
                if (minimoItems > 1) {
                    minimoItems = 1;
                }

                //Recorre todos los precios de los productos de la promo para saber cual es el valor roal de la promo
                for (var k = 0; k < ListCondiciones.length; k++) {
                    var condi = ListCondiciones[k];
                    for (var l = 0; l < minimoItems; l++) {
                        var enc: any = condi[l];
                        valorTotalSinPromo += +lPrecios.find(x => x.ID == enc.ID && x.Indice == enc.Indice).PUNITNETO;
                    }
                }

                //Calcula el valor del porcentaje de la promo a partir del calor del combo y de la suma de los precios originales de los productos
                porcentajePromo = 100 - (+ValorPromo * 100 / valorTotalSinPromo);

                for (var k = 0; k < ListCondiciones.length; k++) {
                    var condi = ListCondiciones[k];
                    for (var l = 0; l < minimoItems; l++) {
                        var enc: any = condi[l];
                        lPrecios.filter(x => x.ID == enc.ID).forEach(precio => {
                            if (precio.Indice == enc.Indice) {
                                if (!precio.PromoAplicada) {
                                    let valor = precio.PUNITNETO;

                                    //Modifica el precio de los productos a su nuevo valor con la promocion aplicada
                                    precio.PUNITNETO = valor - (valor * porcentajePromo / 100);
                                    precio.PromoAplicada = true;
                                }
                                this.agregarProductoAProductosHijos(productosHijosDelCombo, ioM3Proceso, precio);
                            }
                            else {
                                //En las promos por combo no aplican el precio de los otros productos que no hacen parte del combo :)
                                precio.PUNITNETO = 0;
                            }
                        });
                        //lPrecios.find(x => x.ID == enc.ID && x.Indice == enc.Indice).PUNITNETO = -1;
                        flagAplicoPromo = true;
                    }
                }

                if (flagAplicoPromo) {
                    oM3RegService = new M3RegService(null, null, null);
                    //let productoPromoCombiExistente = ioM3Proceso.M3ENC.find(x => x.IdProducto == combi.Accion.Codigo);
                    // if (!productoPromoCombiExistente) {
                    this.CalculateTotalPriceFromList(lPrecios, productosHijosDelCombo, combi, true, bEsAcumulable);
                    // }
                    // else {
                    //     this.CalculateTotalPriceFromList(lPrecios, productosHijosDelCombo, combi, true, bEsAcumulable);
                    // }
                    oM3RegService.loadM3PEncItemsFromPromocionCombo(ioM3Proceso, productosHijosDelCombo, combi.Accion.Codigo, combi.Accion.Valor, 1);
                }

            }
            this.limpiarEncItemPrdCondi(oListEncab);

        } catch (ex) {
            console.log("PromocionCombinadaCombo")
            console.log(ex)
        }
        return flagAplicoPromo;

    }

    filtrarListaCondicionesCombo(listCondiciones: Array<any>, oM3PEncItemsList: Array<M3PEncItems>) {
        for (let _i = 0; _i < listCondiciones.length; _i++) {
            let nuevaCondicion = [];
            for (const condicion of listCondiciones[_i]) {
                let encItem = oM3PEncItemsList.find(x => x.ID == condicion.ID);
                if (encItem) {
                    let detCantidad = encItem.M3DET.find(x => x.NombreConcepto == "CANTIDAD").Valor;
                    encItem["PrdCondi"] = encItem["PrdCondi"] ? encItem["PrdCondi"] : 0;
                    if (detCantidad > encItem["PrdCondi"]) {
                        nuevaCondicion = [condicion];
                        encItem["PrdCondi"]++;
                        break;
                    }
                }
            }
            listCondiciones[_i] = nuevaCondicion;
        }
    }

    limpiarEncItemPrdCondi(oM3PEncItemsList: Array<M3PEncItems>) {
        oM3PEncItemsList.forEach(element => {
            delete element["PrdCondi"];
        });
    }

    agregarAProductosQuitarCombi(oM3Proceso: M3Procesos, oM3PEncItems: M3PEncItems, cantidad = 1) {
        let productoQuitar;
        if (!oM3Proceso["ProductosCombi"]) {
            oM3Proceso["ProductosCombi"] = [];
        }

        productoQuitar = oM3Proceso["ProductosCombi"].find(x => x.ID == oM3PEncItems.IdProducto);
        if (productoQuitar) {
            productoQuitar.Cantidad += (-1 * cantidad);
        }
        else {
            oM3Proceso["ProductosCombi"].push({ ID: oM3PEncItems.IdProducto, Cantidad: (-1 * cantidad) })
        }
    }

    //Agrega el producto de la lista de entrada a un arreglo de productos que posteriormente sera los productos hijos del producto Combo
    agregarProductoAProductosHijos(productosHijosDelCombo: Array<M3PEncItems>, oM3Proceso: M3Procesos, oPrecioDelProductoActual) {
        let oM3PEncItems = this.getProdutoPromoCombo(oM3Proceso.M3ENC, oPrecioDelProductoActual);
        if (oM3PEncItems) {
            let oM3RegService = new M3RegService(null, null, null);
            //La cantidad disminuye pero este movimiento se reversa al terminar de validar esta promo
            oM3RegService.ValoresCalculadosProceso(oM3PEncItems, 1);
            productosHijosDelCombo.push(oM3PEncItems);
            this.agregarAProductosQuitarCombi(oM3Proceso, oM3PEncItems);
        }

    }

    //Disminuye en uno la cantidad del producto y retorna un clon de este
    getProdutoPromoCombo(productosEnM3Proceso: Array<M3PEncItems>, oPrecioDelProductoActual): M3PEncItems {
        let productosDelCombo = new Array<M3PEncItems>();
        let oM3PEncItems = productosEnM3Proceso.find(x => x.ID == oPrecioDelProductoActual.ID)
        if (oM3PEncItems) {
            var oM3PDetalleItems: M3PDetalleItems// = new M3PDetalleItems();
            oM3PDetalleItems = oM3PEncItems.M3DET.find(d => d.NombreConcepto == "CANTIDAD");
            if (+oM3PDetalleItems.Valor > 0) {
                oM3PDetalleItems.Valor = (+oM3PDetalleItems.Valor - 1).toString();
                return _.cloneDeep(oM3PEncItems);
            }
        }
        return null;
    }

    /**
     * Agregar en hashmap de precios
     * @param hmlPrecios 
     * @param ID 
     */
    public AddtoHmPrecios(hmlPrecios: Array<any>, ID: string) {
        var finded: any = hmlPrecios.find(x => x.ID == ID);
        if (finded) {
            finded.Indice = +finded.Indice + +1;
        } else {
            finded = { "ID": ID, "Indice": 0 };
            hmlPrecios.push(finded);
        }
        return finded.Indice;
    }




    /**
     * Buscar encabezados que tenga la promocion y condicion enviada como parametro
     * @param oListEncab 
     * @param IdCondicion 
     * @param idPromociones 
     */
    public BuscarEncByPromoYCond(oListEncab: Array<M3PEncItems>, IdCondicion: string, idPromociones: string) {
        var oEncFinded = new Array<M3PEncItems>();
        for (var i = 0; i < oListEncab.length; i++) {
            try {
                var oM3PEncItems: M3PEncItems = oListEncab[i];
                console.debug(oM3PEncItems.IdEncPadre)
                if (!oM3PEncItems.IdEncPadre || !(oM3PEncItems.IdEncPadre > 0)) {
                    var det = oM3PEncItems.M3DET.find(x => x.NombreConcepto == "PROMOCOMBI");
                    var detCantidad = oM3PEncItems.M3DET.find(x => x.NombreConcepto == "CANTIDAD");
                    if (det && detCantidad && +detCantidad.Valor > 0) {
                        var promos: Array<any> = JSON.parse(det.Valor);
                        var promoFinded = promos.find(x => x.IdPromocionCombinada == idPromociones)
                        if (promoFinded) {
                            var condicionFinded = promoFinded.Accion.IdCondicion;
                            if (condicionFinded) {
                                if (condicionFinded.length) {
                                    if (condicionFinded.find(x => x == IdCondicion)) {
                                        oEncFinded.push(oM3PEncItems);
                                    }
                                }
                                else {
                                    if (condicionFinded == IdCondicion) {
                                        oEncFinded.push(oM3PEncItems);
                                    }
                                }
                            }
                        }
                    }
                }
            } catch { }
        }
        return oEncFinded;
    }


    /**
     * ValidaciÃ³n si la promociÃ³n que llega como parametro, es acumulable o no
     * @param promocion 
     */
    public GetEsAcumulablePromo(promocion: PromocionCombinada) {
        try {
            if (promocion.Accion.Regla && promocion.Accion.Regla == "ACM") {
                return true;
            }
        } catch (ex) {
            console.log("Error GetEsAcumulable")
            console.log(ex)
        }


        return false;
    }

    public procesarProductoAplDesc(oListEncab: Array<M3PEncItems>, combi: PromocionCombinada, ioM3Proceso: M3Procesos, esAcumulable: boolean) {
        let lPrecios = new Array<any>();
        let prodsAplDescuento: Array<M3PEncItems> = [];
        let skuAplDescuentos: Array<any> = combi.Accion.skuAplDesc; //[{SKU:"XXXXXX"}, {SKU:"YYYYYYY"}]
        let maxNumDescuentos = +combi.Accion.maxNumDesc;
        let contDescAplicados = 0;

        try {
            //Calcula el numero maximo de descinetos que puede aplicar la promo que es combi.Accion.maxNumDesc multiplicado por la cantidad de productos que palican la promo en el proceso
            maxNumDescuentos = oListEncab.reduce((acc, cur) => {
                return acc + +cur.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor;
            }, 0) * maxNumDescuentos;

            //De los productos del proceso filtro los productos que aplicaran el descuento segun los SKU configurados en combi.Accion.skuAplDesc
            ioM3Proceso.M3ENC.forEach(oM3PEncItems => {
                if (skuAplDescuentos.find(x => x.SKU == oM3PEncItems.IdProducto)) {
                    prodsAplDescuento.push(oM3PEncItems);
                }
            });

            //CÃ¡lculo de los precios unitarios de los productos a los que la promo aplicara descuento
            lPrecios = this.ProcesarPromoCombyByListEnc(prodsAplDescuento, esAcumulable);

            //Aplica tantos descuentos se puedan a plaicar a cada valor de lPrecio
            while (contDescAplicados < maxNumDescuentos && contDescAplicados < lPrecios.length) {
                lPrecios[contDescAplicados].PUNITNETO -= (+lPrecios[contDescAplicados].PUNITNETO) * ((+combi.Accion.Valor) / 100);
                contDescAplicados++;
            }

            //Recalcula los valores del producto aplicando el descuento
            this.CalculateTotalPriceFromList(lPrecios, prodsAplDescuento, combi, true, esAcumulable);
        }
        catch (error) {

        }
    }

    /**
     * Procesamiento de obsequios en el cierre
     * Valida toda la lista de encabezados, teniendo en cuenta la cantidad ingresada en el carrito de compras
     * Valida la promociÃ³n, por cada cuantos productos ingresados, cuÃ¡ntos obsequios se pueden dar.
     * Trae todos los obsequios que se ingresaron en el carrito de compras, los lista
     * coloca en valor 0 los obsequios que selecciono automaticamente el algoritmo
     * Recalculo de precios, impuestos y demas valores totales.
     * @param oListEncab Lista de los productos ingresados al carrito que tienen obsequio
     * @param combi InformaciÃ³n de promociÃ³n de obsequios
     * @param ioM3Proceso Proceso con todos los productos e informaciÃ³n.
     */
    public ProcesarPromoObsqCierre(oListEncab: Array<M3PEncItems>, combi: PromocionCombinada, ioM3Proceso: M3Procesos, esAcumulable: boolean) {

        for (var i = 0; i < oListEncab.length; i++) {
            var oEnc: M3PEncItems = oListEncab[i];
            var cantPorObs: number = +combi.Accion.CantidadObsq; //Por cada cuantos productos con la promociÃ³n se darÃ¡ el obsequio.
            var cantAgregada: number = +oEnc.M3DET.find(d => d.NombreConcepto == "CANTIDAD").Valor;
            var cantObsequios: number = Math.floor(cantAgregada / cantPorObs); //Cantidad de obsequios que se darÃ¡ por esta compra.
            var obsequios: Array<any> = combi.Accion.OBSEQUIOS;
            var oListEncabObsquios = new Array<M3PEncItems>();
            var lPrecio: Array<any>;

            //Traer todos los productos 
            for (var o = 0; o < obsequios.length; o++) {
                var obs: any = obsequios[i];
                var encsObsequios: Array<M3PEncItems> = ioM3Proceso.M3ENC.filter(x => x.IdProducto == obs.SKU);
                encsObsequios.forEach(encob => {
                    oListEncabObsquios.push(encob);
                })
            }

            lPrecio = this.ProcesarPromoCombyByListEnc(oListEncabObsquios, esAcumulable);
            if (lPrecio.length > 0) {
                if (cantObsequios > lPrecio.length) {
                    cantObsequios = lPrecio.length;
                }
                for (var p = 0; p < cantObsequios; p++) {
                    lPrecio[p].PUNITNETO = 0;
                }
                this.CalculateTotalPriceFromList(lPrecio, oListEncabObsquios, combi, false, esAcumulable);
            }
        }
    }


    /**
    * Aplicar reglas, respecto a la cantidad ingresada.
    * @param oPromocionesAsociadas 
    * @param oPromocionProcesada 
    */
    public AplicarReglaModCantidad(lPrecios: Array<any>, oListEncab: Array<M3PEncItems>, combi: PromocionCombinada, bEsAcumulable: boolean) {
        var Accion = combi.Accion;

        var iCantidadPromo: number = Accion.Cantidad; //Ejemplo : 3
        //var iCantidadAPLPromo: number; //Numero real de aplicacion de promociones, Si aplica resta el residuo.
        var iCantidadReal: number; //Cantidad real ingresada.
        var ValorPromo: number = Accion.Valor;
        var valorPromoUnit: number = (+ValorPromo) / (+iCantidadPromo)
        iCantidadReal = lPrecios.length;

        if (iCantidadReal >= iCantidadPromo) { //JAGM 20190426 SE CAMBIA, ANTES ESTABA LA FUNCIONALIDAD DE CANTIDAD REAL VS CANTIDAD PROMOCION.
            if (iCantidadReal % iCantidadPromo == 0) {
                //iCantidadAPLPromo = iCantidadReal / iCantidadPromo;
            } else {
                var Residuo: number = iCantidadReal % iCantidadPromo;
                iCantidadReal = iCantidadReal - Residuo;
                //iCantidadAPLPromo = iCantidadReal / iCantidadPromo;
            }

            for (var i = 0; i < iCantidadReal; i++) {
                if (lPrecios[i].PUNITNETO > valorPromoUnit) {
                    lPrecios[i].PUNITNETO = valorPromoUnit;
                    lPrecios[i].Aplicado = true;
                }
            }
            if (lPrecios.find(x => x.Aplicado)) {
                console.debug("AplicarReglaModCantidad")
                this.CalculateTotalPriceFromList(lPrecios, oListEncab, combi, true, bEsAcumulable);
            }
        }
    }

    /**
     * Cargar combinadas desde dinamicas
     * @param ioM3Proceso 
     */
    public GetCombinadasFromDinamicas(ioM3Proceso: M3Procesos) {
        try {
            var sCombinada = ioM3Proceso.lM3PDinamicas.find(x => x.Nombre == "COMBINADA").Valor;
            var oCombinada = JSON.parse(sCombinada);

            ioM3Proceso.PromosCombinadas = oCombinada;
        } catch {

        }
    }

    /**
     * Adicionar a dinamicas proceso de combinadas
     * @param ioM3Proceso 
     */
    public AddDinamicaProcesoCombinadas(ioM3Proceso: M3Procesos) {
        var oM3PDinamicasFinded: M3PDinamicas;
        oM3PDinamicasFinded = ioM3Proceso.lM3PDinamicas.find(x => x.Nombre == "COMBINADA");
        if (oM3PDinamicasFinded) {
            var arrPromo: Array<PromocionCombinada> = JSON.parse(oM3PDinamicasFinded.Valor);
            for (var i = 0; i < arrPromo.length; i++) {
                var oPromoCombi: PromocionCombinada = ioM3Proceso.PromosCombinadas.find(x => x.IdPromocionCombinada == arrPromo[i].IdPromocionCombinada);
                if (!oPromoCombi) {
                    ioM3Proceso.PromosCombinadas.push(arrPromo[i]);
                }
            }
            oM3PDinamicasFinded.Valor = JSON.stringify(ioM3Proceso.PromosCombinadas);
        } else {
            var oM3PDinamicas = new M3PDinamicas();
            oM3PDinamicas.Nombre = "COMBINADA";
            oM3PDinamicas.Valor = JSON.stringify(ioM3Proceso.PromosCombinadas);

            ioM3Proceso.lM3PDinamicas.push(oM3PDinamicas);
        }

    }

    /**
     * Calcular promociones, segun la lista de precios dividida.
     * @param lPrecios Lista de precios, contra este objeto se iterarÃ¡ y se ordenarÃ¡ de mayor a menor
     * @param oListEncab 
     * @param combi 
     */
    public CalcularPromocionesByListaPrec(lPrecios: Array<any>, oListEncab: Array<M3PEncItems>, combi: PromocionCombinada, bEsAcumulable: boolean) {
        var TipoPromo = combi.Tipo2;
        var ix: number = 0;
        var iy: number = 0;
        var x: number = +TipoPromo.split("X")[1]
        var y: number = +TipoPromo.split("X")[0] - (+x);
        var residuoX: number = 0;
        var bEntro: boolean = false;

        if (x.toString().split(".").length > 1) {
            residuoX = +x.toString().split(".")[1];
            x = +x.toString().split(".")[0];
        }

        ///Se itera el arreglo de principio a fin y de fin a principio... 
        ///Conforme se recorre el arreglo de fin a prinicio, se va dando la promociÃ³n a los productos de menor valor.
        ///Si la promociÃ³n esta incompleta, los productos de la mitad quedan sin promociÃ³n 
        var i: number = 0;
        lPrecios = lPrecios.sort((a, b) => a.PUNITNETO < b.PUNITNETO ? 1 : a.PUNITNETO > b.PUNITNETO ? -1 : 0)
        if (lPrecios.length > 0) {
            var j = +lPrecios.length - 1;
            while (i < lPrecios.length && j >= i) {

                ix = 0;
                iy = 0;

                while (ix < x) {

                    ix++;
                    i++;
                }
                while (iy < y && j >= i) {

                    if (residuoX == 0) {
                        bEntro = true;
                        lPrecios[j].PUNITNETO = 0;
                    } else {
                        bEntro = true;
                        ///Para las promocion como: 2X1.5, ...
                        //Esta soportando solo para: 2X1.5
                        lPrecios[j].PUNITNETO = +lPrecios[j].PUNITNETO * (+residuoX / 10);
                    }
                    iy++;
                    j--;
                }

            }
            //Calcular precios totales
            //Teniendo en cuenta la informacion de los precios unitarios.
            //JGAM 20191023, funcionalidad de que solo entra acÃ¡ cuando se cambio algun precio
            if (bEntro) {
                this.CalculateTotalPriceFromList(lPrecios, oListEncab, combi, false, bEsAcumulable);
            }


            // for (var i = 0; i < oListEncab.length; i++) {
            //     var enc: M3PEncItems = oListEncab[i];
            //     enc.M3DET.find(det => det.NombreConcepto == "PRECIOTOTAL").Valor = lPrecios.filter(x => x.ID == enc.ID).
            //         reduce((acc, cur) => (+acc) + (+cur.PUNITNETO), 0);

            //     this.SetValorPromociones(enc);
            //     this.AgregarListaPromo(enc, combi);
            // }
        }
    }
    /**
     * Calcular precio total teniendo en cuenta la lista de precios
     * @param lPrecios Lista de precios a tener en cuenta
     * @param oListEncab Lista de encabezados
     * @param combi Promocion combinada
     */
    public CalculateTotalPriceFromList(lPrecios: Array<any>, oListEncab: Array<M3PEncItems>, combi: PromocionCombinada, bAplValida: boolean, bEsAcumulable: boolean) {
        //Calcular precios totales
        //Teniendo en cuenta la informacion de los precios unitarios.
        var dValorPromoAnt: number = 0;
        //var dValorPromoAntAcum: number = 0;
        var dValorAct: number = 0;
        for (var i = 0; i < oListEncab.length; i++) {
            var enc: M3PEncItems = oListEncab[i];
            var dPrecioNuevo = lPrecios.filter(x => x.ID == enc.ID).
                reduce((acc, cur) => (+acc) + (+cur.PUNITNETO), 0);
            var precioTotalAnterior;
            precioTotalAnterior = enc.M3DET.find(det => det.NombreConcepto == "PRECIOTOTAL").Valor;

            //JAGM 20190718 SE QUITA VALIDACION, POR FLUJO QUE SI SE DEVUELVE TRAE LA PROMO, PERO SI SE BORRA. if (dPrecioNuevo < precioTotalAnterior) { // Se agrega validacion de precio, para escoger el mejor. No pueden a ver 2 promociones.
            enc.M3DET.find(det => det.NombreConcepto == "PRECIOTOTAL").Valor = dPrecioNuevo;
            //enc.M3DET.find(det => det.NombreConcepto == "PRECIOTOTALREAL").Valor = dPrecioNuevo;
            //Limpiar promociones
            if ((this.ValidarSiTodosAPLPromoCombinada(lPrecios, enc) || !bAplValida) && !bEsAcumulable) {
                if (enc.M3DET.find(det => det.NombreConcepto == "NOMB_PROMOC")) {
                    enc.M3DET.find(det => det.NombreConcepto == "NOMB_PROMOC").Valor = ""
                }
                if (enc.M3DET.find(det => det.NombreConcepto == "VAL_PROMOC")) {
                    enc.M3DET.find(det => det.NombreConcepto == "VAL_PROMOC").Valor = ""
                }
                if (enc.M3DET.find(det => det.NombreConcepto == "NOMB_PRO_COMBI")) {
                    enc.M3DET.find(det => det.NombreConcepto == "NOMB_PRO_COMBI").Valor = ""
                }
                if (enc.M3DET.find(det => det.NombreConcepto == "VAL_PRO_COMBI")) {
                    enc.M3DET.find(det => det.NombreConcepto == "VAL_PRO_COMBI").Valor = ""
                }
                if (enc.M3DET.find(det => det.NombreConcepto == "ID_PRO_COMBI")) {
                    enc.M3DET.find(det => det.NombreConcepto == "ID_PRO_COMBI").Valor = ""
                }
                this.QuitarLasPromosDirectas(enc);
                this.QuitarLasPromosCombinadas(enc);
                // enc.M3DET.find(det => det.NombreConcepto == "NOMB_PROMOC").Valor = "";
                // enc.M3DET.find(det => det.NombreConcepto == "VAL_PROMOC").Valor = "";
                dValorAct = ((+enc.M3DET.find(det => det.NombreConcepto == "PRECIOTOTALSINDTO").Valor) - (+enc.M3DET.find(det => det.NombreConcepto == "PRECIOTOTAL").Valor))
            } else {
                dValorPromoAnt = this.GetValorPromoAnterior(lPrecios, enc);
                dValorAct = this.GetValorPromoACt(enc, dValorPromoAnt, dPrecioNuevo, precioTotalAnterior, bEsAcumulable);
                //JAGM 20190730 se agrega para promociones acumulables. acumulab
                if (!bEsAcumulable) {
                    enc.M3DET.find(det => det.NombreConcepto == "VAL_PROMOC").Valor = dValorPromoAnt.toString();
                } else {
                    //Es acumulable, utilizar la informaciÃ³n 
                    dValorPromoAnt = (+enc.M3DET.find(det => det.NombreConcepto == "PRECIOTOTALSINDTO").Valor - precioTotalAnterior)
                }

            }
            this.SetValorPromociones(enc, dValorAct + dValorPromoAnt);
            this.AgregarListaPromo(enc, combi, dValorAct);
            this.RecalcularPrecioUnitFromTotal(enc, dPrecioNuevo);
            //}
        }
    }


    public QuitarLasPromosDirectas(enc: M3PEncItems) {
        try {
            enc.M3DET.filter(x => x.NombreConcepto.toUpperCase().startsWith("VAL_PROMOC_")).forEach(det => {
                det.Valor = "0";
            });
        } catch {

        }
    }

    public QuitarLasPromosCombinadas(enc: M3PEncItems) {
        try {
            enc.M3DET.filter(x => x.NombreConcepto.toUpperCase().startsWith("VAL_PRO_COMBI_")).forEach(det => {
                det.Valor = "0";
            });
        } catch {

        }
    }

    /**
     * Recalcular precio unitario, a partir de un nuevo precio Total.
     * @param enc 
     * @param newPrice 
     */
    public RecalcularPrecioUnitFromTotal(enc: M3PEncItems, newPrice: number) {
        enc.M3DET.find(det => det.NombreConcepto == "PUNITNETO").Valor = (+newPrice / +enc.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor).toString();
    }


    /**
     * Valida si todos los precios de un producto se cambiaron o no.
     * @param lPrecios Lista con todos los items
     * @param enc 
     */
    public ValidarSiTodosAPLPromoCombinada(lPrecios: Array<any>, enc: M3PEncItems) {
        //Check, si alguno de la lista de precio es igual al precio anterior
        var precioAnterior = lPrecios.filter(x => x.ID == enc.ID).find(x => x.PUNITNETO == enc.M3DET.find(x => x.NombreConcepto == "PUNITNETO").Valor);
        if (precioAnterior) {
            return false;
        } else {
            return true;
        }
    }

    /**
     * Obtener valores de promociones dependiendo del numero de items que no se modificaron
     * @param lPrecios 
     * @param enc 
     */
    public GetValorPromoAnterior(lPrecios: Array<any>, enc: M3PEncItems) {
        try {
            var dValor = enc.M3DET.find(x => x.NombreConcepto == "PUNITNETO").Valor;
            var numeroItems = lPrecios.filter(x => x.ID == enc.ID && x.PUNITNETO == dValor).length;
            var dUnitPromo = enc.M3DET.find(x => x.NombreConcepto == "VUNITPROMO").Valor;
            return +numeroItems * +dUnitPromo;
        } catch {
            return 0;
        }
    }

    /**
     * Obtener valor de la promocion que se esta procesando actualmente
     * @param enc 
     * @param valorPromoAnt 
     * @param valotTotalNuevo 
     */
    public GetValorPromoACt(enc: M3PEncItems, valorPromoAnt: number, valotTotalNuevo: number, precioTotalAnt: number, bEsAcumulable: boolean) {
        try {
            var valorTotalSinDto: number;
            var valorPromoAct: number;
            //JAGM 20190730 si viene acumulable utilizar el precio anterior, teniendo en cuenta el dto.
            if (bEsAcumulable) {
                valorTotalSinDto = precioTotalAnt;
                valorPromoAct = +valorTotalSinDto - +valotTotalNuevo;
            } else {
                valorTotalSinDto = +enc.M3DET.find(det => det.NombreConcepto == "PRECIOTOTALSINDTO").Valor;
                valorPromoAct = +valorTotalSinDto - +valorPromoAnt - +valotTotalNuevo;
            }


            return valorPromoAct;
        } catch (ex) {
            console.log("Error GetValorPromoACt: ");
            console.log(ex);
        }

    }






    /**
     * Setear el valor de la promocion
     * @param enc Encabezado de items
     */
    public SetValorPromociones(enc: M3PEncItems, valorPromo: number) {
        try {
            //enc.M3DET.find(det => det.NombreConcepto == "TOTALPROMO").Valor = ((+enc.M3DET.find(det => det.NombreConcepto == "PRECIOTOTALSINDTO").Valor) - (+enc.M3DET.find(det => det.NombreConcepto == "PRECIOTOTAL").Valor)).toString();
            //FS 20190725 Redondeo del valor de promocion
            enc.M3DET.find(det => det.NombreConcepto == "TOTALPROMO").Valor = (Math.round(valorPromo * 100) / 100).toString();
            //JAGM 20190618 Se agrega el valor unitario de la promociÃ³n
            enc.M3DET.find(det => det.NombreConcepto == "VUNITPROMO").Valor = (+(Math.round(valorPromo * 100) / 100) / +enc.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor).toString();
        } catch {
        }
    }


    //  /**
    //  * Setear el valor de la promocion
    //  * @param enc Encabezado de items
    //  */
    // public SetValorPromocionesFromListaPrecios(enc: M3PEncItems, lPrecios: Array<any>) {
    //     try {
    //         enc.M3DET.find(det => det.NombreConcepto == "TOTALPROMO").Valor = lPrecios.filter(x => x.ID == enc.ID && x.PUNITNETO == dValor)
    //     } catch{
    //     }
    // }


    // public CalcularPromocionesByListaPrecBeta(lPrecios: Array<any>, oListEncab: Array<M3PEncItems>, combi: PromocionCombinada) {
    //     if (lPrecios.length > 0) {
    //         var TipoPromo = combi.Tipo2;
    //         var iSizePrec: number = lPrecios.length;
    //         var iMitad: number;

    //         var residuoX: number = 0;
    //         var x: number = +TipoPromo.split("X")[1]
    //         var y: number = +TipoPromo.split("X")[0] - (+x);
    //         var iDto: number;

    //         if (x.toString().split(".").length > 1) {
    //             residuoX = +x.toString().split(".")[1];
    //         }

    //         iMitad = (+y) / (+iSizePrec);
    //         iMitad = Math.ceil((+iMitad) * (+x)) - 1;

    //         lPrecios = lPrecios.sort((a, b) => a.PUNITNETO < b.PUNITNETO ? 1 : a.PUNITNETO > b.PUNITNETO ? -1 : 0)

    //         var iX = 0;
    //         if (lPrecios.length > 0) {
    //             iDto = iMitad;
    //             while (iDto < iSizePrec) {
    //                 if (residuoX == 0) {
    //                     lPrecios[iDto].PUNITNETO = 0;
    //                     iDto++;
    //                 } else {
    //                     ///Para las promocion como: 2X1.5, ...
    //                     //Esta soportando solo para: 2X1.5
    //                     lPrecios[iDto].PUNITNETO = +lPrecios[iDto].PUNITNETO * (+residuoX / 10);
    //                     // while(iX < x){
    //                     //     lPrecios[iDto].PUNITNETO = +lPrecios[iDto].PUNITNETO * (+residuoX / 10);
    //                     //     iX++;
    //                     //     iDto++;
    //                     // }
    //                     // iX = 0;

    //                 }

    //             }

    //             //Calcular precios totales
    //             //Teniendo en cuenta la informacion de los precios unitarios.
    //             for (var i = 0; i < oListEncab.length; i++) {
    //                 var enc: M3PEncItems = oListEncab[i];
    //                 enc.M3DET.find(det => det.NombreConcepto == "PRECIOTOTAL").Valor = lPrecios.filter(x => x.ID == enc.ID).
    //                     reduce((acc, cur) => (+acc) + (+cur.PUNITNETO), 0);
    //             }
    //         }
    //     }
    // }

    /**
     * Adicionar a lista de detalle el:  NOMB_PROMOC, VAL_PROMOC y ID_PROMOC
     * @param enc 
     * @param combi 
     */
    public AgregarListaPromo(enc: M3PEncItems, combi: PromocionCombinada, dValorPromoCombi: number) {
        var detNombres: string;
        var detValores: string;
        var detIds: string;

        var oM3PDetalleItemsNames: M3PDetalleItems// = new M3PDetalleItems();
        var oM3PDetalleItemsVals: M3PDetalleItems// = new M3PDetalleItems();
        var oM3PDetalleItemsIds: M3PDetalleItems// = new M3PDetalleItems();


        oM3PDetalleItemsNames = enc.M3DET.find(d => d.NombreConcepto == "NOMB_PRO_COMBI");
        oM3PDetalleItemsVals = enc.M3DET.find(d => d.NombreConcepto == "VAL_PRO_COMBI");
        oM3PDetalleItemsIds = enc.M3DET.find(d => d.NombreConcepto == "ID_PRO_COMBI");

        if (oM3PDetalleItemsNames) {

        } else {
            oM3PDetalleItemsNames = new M3PDetalleItems();
            oM3PDetalleItemsVals = new M3PDetalleItems();
            oM3PDetalleItemsIds = new M3PDetalleItems();
            oM3PDetalleItemsNames.NombreConcepto = "NOMB_PRO_COMBI"
            oM3PDetalleItemsVals.NombreConcepto = "VAL_PRO_COMBI"
            oM3PDetalleItemsIds.NombreConcepto = "ID_PRO_COMBI"

            oM3PDetalleItemsNames.Valor = ""
            oM3PDetalleItemsVals.Valor = ""
            oM3PDetalleItemsIds.Valor = ""

            enc.M3DET.push(oM3PDetalleItemsNames)
            enc.M3DET.push(oM3PDetalleItemsVals)
            enc.M3DET.push(oM3PDetalleItemsIds)

        }


        oM3PDetalleItemsNames.Valor = oM3PDetalleItemsNames.Valor + combi.Nombre + ",";
        oM3PDetalleItemsIds.Valor = oM3PDetalleItemsIds.Valor + combi.IdPromocionCombinada + ",";
        oM3PDetalleItemsVals.Valor = oM3PDetalleItemsVals.Valor + dValorPromoCombi.toString() + ",";

        //Ahora se agrega una dinamica por atributo de la promo para facilitar la retoma de esta informaciÃ³n
        let listNombre = oM3PDetalleItemsNames.Valor.replace(/.$/, "").split(",");
        let listId = oM3PDetalleItemsIds.Valor.replace(/.$/, "").split(",");
        let listValor = oM3PDetalleItemsVals.Valor.replace(/.$/, "").split(",");

        for (let _i = 0; _i < listId.length; _i++) {
            this.actualizarOCrearPDinamica(enc.M3DET, listNombre[_i], "NOMB_PRO_COMBI_" + _i);
            this.actualizarOCrearPDinamica(enc.M3DET, listNombre[_i], "ID_PRO_COMBI_" + _i);
            this.actualizarOCrearPDinamica(enc.M3DET, listNombre[_i], "VAL_PRO_COMBI_" + _i);
        }
    }

    actualizarOCrearPDinamica(arrayDinamicas: Array<M3PDetalleItems>, nombreDinamica: string, ValorDinamica: string) {
        let oM3PDetalleItems = arrayDinamicas.find(x => x.NombreConcepto == nombreDinamica);
        if (oM3PDetalleItems) {
            oM3PDetalleItems.Valor = ValorDinamica;
        }
        else {
            oM3PDetalleItems = new M3PDetalleItems();
            oM3PDetalleItems.NombreConcepto = nombreDinamica;
            oM3PDetalleItems.Valor = ValorDinamica;
            arrayDinamicas.push(oM3PDetalleItems);
        }
    }

    /**
     * Obtener la lista de encabezados, que aplican a la lista combinada que tiene
     * @param oPromocionCombinada Objeto de promocion combianda
     * @param ioM3Proceso Objeto de M3Proceso
     */
    private GetEncabezadoByCombi(oPromocionCombinada: PromocionCombinada, ioM3Proceso: M3Procesos) {
        try {
            var oListEncab: Array<M3PEncItems>;
            oListEncab = ioM3Proceso.M3ENC.filter(enc => {
                if (enc.PromoCombinadas === undefined) {
                    this.SetPromoCombinadaENC(enc);
                }
                if (!(enc.IdEncPadre > 0)) {
                    if (enc.PromoCombinadas && +enc.M3DET.find(d => d.NombreConcepto == "CANTIDAD").Valor > 0) {
                        //JAGM 20191208 se cambia validacion, para que tenga en cuenta cualquier promocion combinada
                        // return enc.PromoCombinadas.length > 0 && enc.PromoCombinadas[0].IdPromocionCombinada == oPromocionCombinada.IdPromocionCombinada
                        return enc.PromoCombinadas.length > 0 && enc.PromoCombinadas.find(x => x.IdPromocionCombinada == oPromocionCombinada.IdPromocionCombinada);
                    } else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            });
            return oListEncab;
        } catch {
            return null;
        }
    }

    public SetPromoCombinadaENC(oM3PEncItems: M3PEncItems) {
        try {
            var oM3PDetalleItems: M3PDetalleItems;
            oM3PDetalleItems = oM3PEncItems.M3DET.find(x => x.NombreConcepto == "PROMOCOMBI")
            if (oM3PDetalleItems) {
                oM3PEncItems.PromoCombinadas = JSON.parse(oM3PDetalleItems.Valor);
            }
        } catch {

        }
    }

    /**
     * Crear lista de precios y id de encabezado, teniendo en cuenta la informacion lista de encabezados
     * @param oListEncab Lista de encabezados a procesar
     */
    private ProcesarPromoCombyByListEnc(oListEncab: Array<M3PEncItems>, bEsAcumulable: boolean) {
        ///DesAcoplar lista de encabezados a precios totales
        var lPrecios = new Array<any>();
        for (var i = 0; i < oListEncab.length; i++) {
            var enc: M3PEncItems = oListEncab[i];
            var nCantidad: number;
            var nPrecioUnit: number;
            nCantidad = +enc.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor;

            //JAGM 20190730 valida si la promocion es acumulable.
            if (bEsAcumulable) {
                nPrecioUnit = +enc.M3DET.find(det => det.NombreConcepto == "PUNITNETO").Valor
            } else {
                nPrecioUnit = +enc.M3DET.find(det => det.NombreConcepto == "PUNIT").Valor
            }
            for (var j = 0; j < nCantidad; j++) {
                lPrecios.push({ "Indice": j, "PUNITNETO": nPrecioUnit, "ID": enc.ID });
            }
        }
        return lPrecios;

    }


    // /**
    //  * Crear lista de precios y id de encabezado, teniendo en cuenta la informacion lista de encabezados
    //  * @param oListEncab Lista de encabezados a procesar
    //  */
    // private ProcesarPromoCombyByListEnc(oListEncab: Array<M3PEncItems>, bEsAcumulable: boolean) {
    //     ///DesAcoplar lista de encabezados a precios totales
    //     var lPrecios = new Array<any>();
    //     for (var i = 0; i < oListEncab.length; i++) {
    //         var enc: M3PEncItems = oListEncab[i];
    //         var nCantidad: number;
    //         var nPrecioUnit: number;
    //         nCantidad = +enc.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor;

    //         //JAGM 20190730 valida si la promocion es acumulable.
    //         if (bEsAcumulable) {
    //             nPrecioUnit = +enc.M3DET.find(det => det.NombreConcepto == "PUNITNETO").Valor
    //         } else {
    //             nPrecioUnit = +enc.M3DET.find(det => det.NombreConcepto == "PUNIT").Valor
    //         }
    //         for (var j = 0; j < nCantidad; j++) {
    //             lPrecios.push({ "Indice": j, "PUNITNETO": nPrecioUnit, "ID": enc.ID });
    //         }
    //     }
    //     return lPrecios;

    // }
    ///////////////////////////////FIN V2 COMBINADA


    /**
    * ProcesarCombinadaXporY
    * Procesar promocion combinada que se llevan x productos por el precion de y productos.
    */
    public ProcesarCombinadaXporY(oM3Procesos: M3Procesos, m3EncAgregado: M3PEncItems) {
        var m3EncsConPromo: Array<M3PEncItems>;
        var m3CombinadaxProceso: M3PromCombinadaXProceso;

        //Valida si el producto agregado, tiene una misma promocion activa en la factura.
        // if (oM3Procesos.lM3PromCombinada != null && oM3Procesos.lM3PromCombinada.length > 0) {
        //     m3CombinadaxProceso = oM3Procesos.lM3PromCombinada.find(combinadas => combinadas.IdPromocion == m3EncAgregado.PromoCombinadas[0].IdPromocionCombinada && combinadas.Terminada == false);
        //     //Valida si ya existe un proceso.
        //     if (m3CombinadaxProceso != null) {
        //         m3EncAgregado.PromoCombinadas[0].IdPromocionXProceso = m3CombinadaxProceso.IdPromocionXProceso;
        //         //Trae los Encabezados con la promocion 
        //         m3EncsConPromo = oM3Procesos.M3ENC.filter(encs => encs.PromoCombinadas != null && encs.PromoCombinadas.length > 0 && encs.PromoCombinadas[0].IdPromocionXProceso == m3CombinadaxProceso.IdPromocionXProceso);
        //         this.RecalcularPromoXPorY(m3EncsConPromo, m3CombinadaxProceso);
        //     } else {
        //         this.AgregarPromocionCombinadaAProceso(oM3Procesos, m3EncAgregado.PromoCombinadas[0]);
        //     }
        // } else {
        //     oM3Procesos.lM3PromCombinada = new Array<M3PromCombinadaXProceso>();
        //     this.AgregarPromocionCombinadaAProceso(oM3Procesos, m3EncAgregado.PromoCombinadas[0]);
        // }
    }


    //recalcular promocion, dependiendo de la informacion de los encabezados.
    //1.Validar si ya estan todos los items para recalcular la promocion
    //2. Ordenar los encabezados de mayor a menor precio.
    //3. Dejar el precio de los items de menor precion en 0
    // public RecalcularPromoXPorY(m3EncsConPromo: Array<M3PEncItems>, m3CombinadaxProceso: M3PromCombinadaXProceso) {
    //     var oPromocionCombinada: PromocionCombinada;
    //     var varx: number;
    //     var vary: number;
    //     var parteDecY: number = 0;
    //     oPromocionCombinada = m3EncsConPromo[0].PromoCombinadas[0];

    //     varx = parseFloat(oPromocionCombinada.Tipo2.trim().toUpperCase().split("_")[1].split("X")[0]);
    //     vary = parseFloat(oPromocionCombinada.Tipo2.trim().toUpperCase().split("_")[1].split("X")[1]);

    //     if (String(vary).includes(".")) {
    //         parteDecY = parseFloat(oPromocionCombinada.Tipo2.trim().toUpperCase().split("_")[1].split("X")[1].split(".")[1]);
    //         vary = parseFloat(String(vary).split(".")[0]);
    //     }

    //     if (varx == m3EncsConPromo.length) {
    //         m3CombinadaxProceso.Terminada = true;
    //         //Ordenar los encabezados por precio mayor a menor
    //         m3EncsConPromo = m3EncsConPromo.sort((a, b) =>
    //             (a.M3DET.find(det => det.NombreConcepto == "PUNITNETO").Valor < b.M3DET.find(det => det.NombreConcepto == "PUNITNETO").Valor) ? 1 :
    //                 ((b.M3DET.find(det => det.NombreConcepto == "PUNITNETO").Valor < a.M3DET.find(det => det.NombreConcepto == "PUNITNETO").Valor) ? -1 : 0));

    //         for (let i = 0; i < m3EncsConPromo.length; i++) {
    //             //Valida si ya 
    //             if (parteDecY != 0 && (+i) == (+vary)) {
    //                 console.log(parteDecY);
    //                 m3EncsConPromo[i].M3DET.find(det => det.NombreConcepto == "PUNITNETO").Valor = ((+m3EncsConPromo[i].M3DET.find(det => det.NombreConcepto == "PUNITNETO").Valor) * (+(+parteDecY) / 100)).toString();
    //             } else if ((+i) + 1 > vary) {
    //                 m3EncsConPromo[i].M3DET.find(det => det.NombreConcepto == "PUNITNETO").Valor = "0";
    //             }
    //         }
    //     }



    // }

    //--------------------------> Fin Procesamiento Combinada <--------------------------------

    /**
     * Retorna el total de puntos de fidelizacion en la transacciÃ³n redondeados hacÃ­a abajo
     * @param oM3Procesos 
     */
    public get_total_fidelizacion(oM3Procesos: M3Procesos) {
        let total_fidelizacion = 0;
        if (oM3Procesos !== undefined && oM3Procesos.M3ENC !== undefined) {
            total_fidelizacion = oM3Procesos.M3ENC.filter(enc => (+enc.M3DET.find(det => det.NombreConcepto == "FIDELIZACION").Valor) > 0).
                reduce((acc, cur) => (acc) + (((+cur.M3DET.find(det => det.NombreConcepto == "FIDELIZACION").Valor) / 100) * (+cur.M3DET.find(det => det.NombreConcepto == "PRECIOTOTAL").Valor)), 0)
        }
        //Se redondeara no aca sino en la suma total del fidelizacion de cada forma de pago
        return total_fidelizacion;
    }

    /**
     * Obtiene el valor del fidelizacion de un proceso, evaluando cada forma de pago
     * @param proceso 
     * @param list_enc_promo 
     */
    public get_value_fidelizacion_by_proceso(proceso: M3Procesos, list_enc_promo: Array<M3ENCPROMO>) {

        var pago_total_proceso: number = proceso.ValorNeto;
        //var max_value_fidelizacion: number = this.get_total_fidelizacion(proceso);
        var real_value_fidelizacion: number = 0;

        var list_condi_promo = this.get_list_condi_promo_by_actividad(list_enc_promo, "PAGO", "MONEDERO");

        if (proceso.lM3PEncFP) {
            for (var _i = 0; _i < proceso.lM3PEncFP.length; _i++) {
                var forma_pago: M3PEncFP = proceso.lM3PEncFP[_i];
                let promoAplicada: M3CONDIPROMO;
                let aplica_fidelizacion = this.validate_condi_by_forma_pago(forma_pago, list_condi_promo);

                if (aplica_fidelizacion.length > 0) {
                    let valorPago = forma_pago.Valor - forma_pago.ValCambio;
                    real_value_fidelizacion += this.calculate_fidelizacion_by_forma_pago(pago_total_proceso, proceso.M3ENC, valorPago, aplica_fidelizacion, list_enc_promo);
                }
            }
        }

        // if (real_value_fidelizacion > max_value_fidelizacion) {
        //     real_value_fidelizacion = max_value_fidelizacion;
        // }

        real_value_fidelizacion = this.oMathTF.round(real_value_fidelizacion, 2);
        return real_value_fidelizacion;
    }

    /**
     * Retorna las restricciones Activas de tipo de pago a partir de Array<M3CONDIPROMO>
     * @param listCondiPromoTPRestringido .
     * @param listM3EncItem 
     */
    public getRestriccionesTipoPagoActivas(listCondiPromoTPRestringido: Array<M3CONDIPROMO>, listM3EncItem: Array<M3PEncItems>): Array<M3CONDIPROMO> {
        let restriccionesActivas = new Array<M3CONDIPROMO>();
        if (listCondiPromoTPRestringido.length > 0) {
            for (let _i = 0; _i < listM3EncItem.length; _i++) {
                let listM3Det = listM3EncItem[_i].M3DET;
                if (+listM3EncItem[_i].M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor > 0) {
                    let idPromociones = listM3Det.find(x => x.NombreConcepto == "ID_PROMOC");
                    if (idPromociones) {
                        let idPromo = idPromociones.Valor.split(",");
                        for (let _k = 0; _k < idPromo.length; _k++) {
                            let promo = +idPromo[_k];
                            let condiPromo = listCondiPromoTPRestringido.find(x => x.IdPromocion == promo);
                            if (condiPromo && !restriccionesActivas.find(x => x.IdPromocion == promo)) {
                                restriccionesActivas.push(condiPromo)
                            }
                        }
                    }
                }
            }
        }
        return restriccionesActivas;
    }

    /**
     * Retorna las restricciones Activas para los productos del proceso actual
     * @param listEncPromo 
     * @param listM3EncItem 
     */
    public getRestriccionesTipoPagoActivasFromEncPromo(listEncPromo: Array<M3ENCPROMO>, listM3EncItem: Array<M3PEncItems>) {
        let listCondiPromoTPRestringido = this.get_list_condi_promo_by_actividad(listEncPromo, "PAGO", "RESTRICCION_PAGO");

        return this.getRestriccionesTipoPagoActivas(listCondiPromoTPRestringido, listM3EncItem);
    }


    /**
     * Retorna los movimientos realizados por un m3saldosxcuenta
     */
    public m3_get_movimientos_fidelizacion(PostServiceM3: PostServiceM3, idkatios: string, data: any,
        funcionOK: Function, funcionError: Function) {

        //var data = { "id_m3": idm3, "id_proceso": proceso };
        PostServiceM3.getWithBodyM3("M3/m3_get_movimientos_fidelizacion/" + idkatios, data).subscribe(resp => {
            var movs = JSON.parse(resp.toString());
            var resp_movs: Array<any>;
            if (!movs.MOVS.MOV.length) {
                resp_movs = new Array<any>();
                resp_movs.push(movs.MOVS.MOV);
            } else {
                resp_movs = movs.MOVS.MOV;
            }

            funcionOK(resp_movs);
        },
            err => {
                funcionError(err.error.Message);
            });
    }

    /**
     * Valida si la forma de pago cumple alguna condicion de fidelizacion
     * @param forma_pago 
     * @param list_condi_promo: listado de condiciones de fidelizacion
     */
    public validate_condi_by_forma_pago(forma_pago: M3PEncFP, list_condi_promo: Array<M3CONDIPROMO>) {
        //return list_condi_promo[0];
        let promosAplicadas = new Array<M3CONDIPROMO>();
        for (let _i = 0; _i < list_condi_promo.length; _i++) {
            var condi_promo = list_condi_promo[_i];
            var jAdicionales = JSON.parse(condi_promo.JAdicionales);

            switch (condi_promo.Concepto.trim()) {
                case "ID_PAGO":
                    //Si el operador es DIFF crea una expresion regula para excluir lo tipodepago configurados
                    if (jAdicionales.ROOT.Estructura && jAdicionales.ROOT.Estructura.Operacion && jAdicionales.ROOT.Estructura.Operacion == "DIFF") {
                        condi_promo.Valor = "^(?!(" + condi_promo.Valor + ")\\b)\\w+$";
                    }
                    else {
                        condi_promo.Valor = "^(" + condi_promo.Valor + ")$";
                    }
                    var re = new RegExp(condi_promo.Valor, "i");
                    if (re.test(forma_pago.IdTipoPago.toString())) {
                        promosAplicadas.push(condi_promo);
                    }
                    break;
            }
        }
        return promosAplicadas;
    }

    /**
     * Retorna el listado de condiciones validas para una actividad dada
     * @param list_enc_promo 
     */
    public get_list_condi_promo_by_actividad(list_enc_promo: Array<M3ENCPROMO>, actividad: string, tipo2: string): Array<M3CONDIPROMO> {
        var list_condi_promo: Array<M3CONDIPROMO> = new Array<M3CONDIPROMO>();
        var hoy = new Date();

        if (list_enc_promo) {
            for (let _k = 0; _k < list_enc_promo.length; _k++) {
                var encabezadoPromo = list_enc_promo[_k];
                var dVigencia = new Date(encabezadoPromo.Vigencia);
                var dInicio = new Date(encabezadoPromo.Inicio);
                if (encabezadoPromo.Estado && dVigencia >= hoy && dInicio <= hoy && encabezadoPromo.Tipo2 == tipo2) {
                    for (let _i = 0; _i < encabezadoPromo.M3CONDIAGRUPACION.length; _i++) {
                        let condi_agrupacion = encabezadoPromo.M3CONDIAGRUPACION[_i];

                        for (let _j = 0; _j < condi_agrupacion.M3CONDIPROMO.length; _j++) {
                            let condi_promo = condi_agrupacion.M3CONDIPROMO[_j];
                            if (condi_promo.JAdicionales) {
                                var jAdicionales = JSON.parse(condi_promo.JAdicionales);
                                if (jAdicionales.ROOT.ACTIVIDAD && jAdicionales.ROOT.ACTIVIDAD == actividad) {
                                    list_condi_promo.push(condi_promo);
                                }
                            }
                        }
                    }
                }
            }
        }

        return list_condi_promo;
    }

    /**
     * Calcula el valor del fidelizacion de una forma de pago de acuerdo a su porcentaje respecto el valor total del proceso
     * @param pago_total_proceso 
     * @param max_value_fidelizacion 
     * @param value_forma_pago 
     */
    public calculate_fidelizacion_by_forma_pago(pago_total_proceso: number, listM3Enc: M3PEncItems[], value_forma_pago: number, promosAplicada: Array<M3CONDIPROMO>, list_enc_promo: Array<M3ENCPROMO>) {
        let listPromosAplicadas;
        let detalleIdPromoc;
        let valorFidelizacion = 0;
        let percent_forma_pago: number = value_forma_pago / pago_total_proceso;
        var precioProducto = 0;
        for (const item of listM3Enc) {
            listPromosAplicadas = [];
            detalleIdPromoc = item.M3DET.find(x => x.NombreConcepto == "ID_PROMOC");
            precioProducto = +item.M3DET.find(det => det.NombreConcepto == "PRECIOTOTAL").Valor;
            if (detalleIdPromoc && detalleIdPromoc.Valor) {
                listPromosAplicadas = detalleIdPromoc.Valor.split(",");
            }
            for (const promoApl of promosAplicada) {
                if (listPromosAplicadas.find(x => +x == promoApl.IdPromocion)) {
                    let promo = list_enc_promo.find(x => x.IdPromocion == promoApl.IdPromocion);
                    valorFidelizacion += (precioProducto * this.getPorcentajeFidelizacionFromEncPromo(promo) / 100) * (percent_forma_pago);
                    break;
                }
            }
        }
        return valorFidelizacion;
    }

    getPorcentajeFidelizacionFromEncPromo(promo) {
        try {
            let jAdicionales = JSON.parse(promo.JAdicionales);
            if (jAdicionales.ROOT && jAdicionales.ROOT.Accion && jAdicionales.ROOT.Accion.Valor) {
                return jAdicionales.ROOT.Accion.Valor;
            }
        } catch {
        }
        return 0;
    }

    /**
     * Adiciona una dinamica con el valor de la fidelizaciÃ³n de dicho proceso y retorna dicho proceso
     * @param proceso 
     * @param list_enc_promo 
     */
    public add_dinamica_fidelizacion_to_proceso(proceso: M3Procesos, list_enc_promo: Array<M3ENCPROMO>): M3Procesos {
        var value_fidelizacion = 0
        if (list_enc_promo) {
            value_fidelizacion = this.get_value_fidelizacion_by_proceso(proceso, list_enc_promo);
        }

        if (value_fidelizacion > 0) {
            var dinamica_fidelizacion: M3PDinamicas = new M3PDinamicas();
            dinamica_fidelizacion.Nombre = "FIDELIZACION"
            dinamica_fidelizacion.Valor = value_fidelizacion.toString();

            proceso.lM3PDinamicas.push(dinamica_fidelizacion);
        }

        return proceso;
    }

    /**
     * Valida la existencia de un documento de fidelizacion en la tabla M3SaldosXCuenta
     * @param PostServiceM3 
     * @param idkatios 
     * @param documento 
     * @param funcionOK 
     * @param funcionError 
     */
    public validate_doc_fidelizacion(PostServiceM3: PostServiceM3, idkatios: string, data: any,
        funcionOK: Function, funcionError: Function) {
        PostServiceM3.getWithBodyM3("M3/validate_doc_fidelizacion/" + idkatios, data).subscribe(resp => {
            var saldo_x_cuenta;
            saldo_x_cuenta = JSON.parse(resp.toString()).RESPUESTA.M3SaldosXCuenta;
            funcionOK(saldo_x_cuenta);
        },
            err => {
                funcionError(err.error.Message);
            });
    }

    /**
     * Actualiza el saldo sumandole el valor enviado
     * @param PostServiceM3 
     * @param idkatios 
     * @param data 
     * @param funcionOK 
     * @param funcionError 
     */
    public actualizar_saldo_fidelizacion(PostServiceM3: PostServiceM3, idkatios: string, data: any,
        funcionOK: Function, funcionError: Function) {
        //data = {"documento":documento, "valor_movimiento":valor_moviento, "pago":pago }
        PostServiceM3.postServiceHttpResFullM3("M3/actualizar_saldo_fidelizacion/" + idkatios, data).subscribe(resp => {
            data.pago.idDiario = resp["_body"].replace('"', '').replace('"', '');
            funcionOK(data.pago);
        },
            err => {
                funcionError(err);
            });
    }

    /**
     * Genera Un bono de devolucion por el valor dado
     * @param PostServiceM3 
     * @param idkatios 
     * @param data = {"proceso",proceso,"valor":valor}
     * @param funcionOK 
     * @param funcionError 
     */
    public m3_generar_bono_devolucion(PostServiceM3: PostServiceM3, idkatios: string, data: any,
        funcionOK: Function, funcionError: Function) {

        PostServiceM3.postServiceHttpResFullM3("M3/m3_generar_bono_devolucion/" + idkatios, data).subscribe(resp => {
            funcionOK(resp);
        },
            err => {
                funcionError(err);
            });
    }

    /**
     * Crea un nuevo registro en la tabla SaldoXCuenta
     * @param PostServiceM3 
     * @param idkatios 
     * @param data 
     * @param funcionOK 
     * @param funcionError 
     */
    public m3InsertSaldoXCuenta(PostServiceM3: PostServiceM3, idkatios: string, data: any,
        funcionOK: Function, funcionError: Function) {
        //var data = { 'Documento': this.documento, 'TDocTitular': '5', 'NDocTitular': this.ndoc_cliente, 'NomCuenta': 'FIDELIZACION', 'ValCuenta': 0 }
        PostServiceM3.postServiceHttpResFullM3("M3/m3InsertSaldoXCuenta/" + idkatios, data).subscribe(resp => {
            funcionOK();
        },
            err => {
                funcionError(err);
            });
    }


    public getCantidadTotal(M3ENC: Array<M3PEncItems>) {
        if (M3ENC) {
            var dCantidad = M3ENC.filter(enc => (+enc.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor) > 0).
                reduce((acc, cur) => (acc) + (+cur.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor), 0);
            if (dCantidad == 0) {
                return 0;
            } else {
                return dCantidad;
            }
        } else {
            return 0;
        }
    }
}